// <auto-generated by scripts/update-player-pool.mjs>
// Generated 2026-11-04T18:30:39.657Z.

export const playerInsightsMeta = {
  "generatedAt": "2026-11-04T18:30:39.657Z",
  "playerPoolFetchedAt": "2026-11-04T18:30:33.793Z",
  "previousPlayerPoolFetchedAt": "2026-10-28T00:00:00.000Z",
  "playerPoolSource": "Sleeper",
  "trendsSource": "Sleeper trending add/drop endpoints",
  "trendsLookbackHours": 24,
  "trendsLimit": 25,
  "statsSource": "nflverse-data player_stats release",
  "requestedStatsSeason": "2025",
  "statsSeason": "2024",
  "statsAsset": "player_stats_2024.csv",
  "statsFallbackUsed": true,
  "errors": [],
  "notes": "Rank movement compares the newly generated pool against the previously committed playerData.js file. Sleeper trends are also fetched live on the home page when the browser can reach Sleeper."
};

export const sleeperTrending = {
  "add": [
    {
      "playerId": "sleeper-11625",
      "sleeperId": "11625",
      "name": "Adonai Mitchell",
      "team": "NYJ",
      "position": "WR",
      "rank": 174,
      "count": 1869144
    },
    {
      "playerId": "sleeper-8132",
      "sleeperId": "8132",
      "name": "Tyler Allgeier",
      "team": "ARI",
      "position": "RB",
      "rank": 99,
      "count": 1289725
    },
    {
      "playerId": "sleeper-6130",
      "sleeperId": "6130",
      "name": "6130",
      "team": null,
      "position": null,
      "rank": null,
      "count": 1140831
    },
    {
      "playerId": "sleeper-13337",
      "sleeperId": "13337",
      "name": "Emmett Johnson",
      "team": "KC",
      "position": "RB",
      "rank": 125,
      "count": 846828
    },
    {
      "playerId": "sleeper-6011",
      "sleeperId": "6011",
      "name": "6011",
      "team": null,
      "position": null,
      "rank": null,
      "count": 725024
    },
    {
      "playerId": "sleeper-HOU",
      "sleeperId": "HOU",
      "name": "HOU",
      "team": null,
      "position": null,
      "rank": null,
      "count": 666365
    },
    {
      "playerId": "sleeper-DET",
      "sleeperId": "DET",
      "name": "DET",
      "team": null,
      "position": null,
      "rank": null,
      "count": 648756
    },
    {
      "playerId": "sleeper-10219",
      "sleeperId": "10219",
      "name": "Chris Rodriguez Jr.",
      "team": "JAX",
      "position": "RB",
      "rank": 139,
      "count": 633303
    },
    {
      "playerId": "sleeper-7042",
      "sleeperId": "7042",
      "name": "Tyler Bass",
      "team": "BUF",
      "position": "K",
      "rank": 243,
      "count": 463715
    },
    {
      "playerId": "sleeper-NO",
      "sleeperId": "NO",
      "name": "NO",
      "team": null,
      "position": null,
      "rank": null,
      "count": 433360
    },
    {
      "playerId": "sleeper-8161",
      "sleeperId": "8161",
      "name": "Malik Willis",
      "team": "MIA",
      "position": "QB",
      "rank": 132,
      "count": 432572
    },
    {
      "playerId": "sleeper-2020",
      "sleeperId": "2020",
      "name": "Cairo Santos",
      "team": "CHI",
      "position": "K",
      "rank": 201,
      "count": 414659
    },
    {
      "playerId": "sleeper-4993",
      "sleeperId": "4993",
      "name": "Mike Gesicki",
      "team": "CIN",
      "position": "TE",
      "rank": 279,
      "count": 408356
    },
    {
      "playerId": "sleeper-13286",
      "sleeperId": "13286",
      "name": "Jadarian Price",
      "team": "SEA",
      "position": "RB",
      "rank": 61,
      "count": 349155
    },
    {
      "playerId": "sleeper-11783",
      "sleeperId": "11783",
      "name": "Ryan Flournoy",
      "team": "DAL",
      "position": "WR",
      "rank": 213,
      "count": 342344
    },
    {
      "playerId": "sleeper-11610",
      "sleeperId": "11610",
      "name": "Malik Washington",
      "team": "MIA",
      "position": "WR",
      "rank": 185,
      "count": 301632
    },
    {
      "playerId": "sleeper-12469",
      "sleeperId": "12469",
      "name": "Dylan Sampson",
      "team": "CLE",
      "position": "RB",
      "rank": 143,
      "count": 301365
    },
    {
      "playerId": "sleeper-NYG",
      "sleeperId": "NYG",
      "name": "NYG",
      "team": null,
      "position": null,
      "rank": null,
      "count": 284060
    },
    {
      "playerId": "sleeper-8135",
      "sleeperId": "8135",
      "name": "8135",
      "team": null,
      "position": null,
      "rank": null,
      "count": 274155
    },
    {
      "playerId": "sleeper-7561",
      "sleeperId": "7561",
      "name": "7561",
      "team": null,
      "position": null,
      "rank": null,
      "count": 256770
    },
    {
      "playerId": "sleeper-11729",
      "sleeperId": "11729",
      "name": "Sione Vaki",
      "team": "DET",
      "position": "RB",
      "rank": 331,
      "count": 238581
    },
    {
      "playerId": "sleeper-4035",
      "sleeperId": "4035",
      "name": "Alvin Kamara",
      "team": "NO",
      "position": "RB",
      "rank": 129,
      "count": 199984
    },
    {
      "playerId": "sleeper-7567",
      "sleeperId": "7567",
      "name": "Kenny Gainwell",
      "team": "TB",
      "position": "RB",
      "rank": 95,
      "count": 169896
    },
    {
      "playerId": "sleeper-CHI",
      "sleeperId": "CHI",
      "name": "CHI",
      "team": null,
      "position": null,
      "rank": null,
      "count": 162451
    },
    {
      "playerId": "sleeper-1479",
      "sleeperId": "1479",
      "name": "Keenan Allen",
      "team": "IND",
      "position": "WR",
      "rank": 192,
      "count": 160552
    }
  ],
  "drop": [
    {
      "playerId": "sleeper-11435",
      "sleeperId": "11435",
      "name": "Emanuel Wilson",
      "team": "SEA",
      "position": "RB",
      "rank": 172,
      "count": 1391310
    },
    {
      "playerId": "sleeper-WAS",
      "sleeperId": "WAS",
      "name": "WAS",
      "team": null,
      "position": null,
      "rank": null,
      "count": 804377
    },
    {
      "playerId": "sleeper-12711",
      "sleeperId": "12711",
      "name": "12711",
      "team": null,
      "position": null,
      "rank": null,
      "count": 671052
    },
    {
      "playerId": "sleeper-NE",
      "sleeperId": "NE",
      "name": "NE",
      "team": null,
      "position": null,
      "rank": null,
      "count": 564627
    },
    {
      "playerId": "sleeper-3271",
      "sleeperId": "3271",
      "name": "3271",
      "team": null,
      "position": null,
      "rank": null,
      "count": 376875
    },
    {
      "playerId": "sleeper-11637",
      "sleeperId": "11637",
      "name": "Keon Coleman",
      "team": "BUF",
      "position": "WR",
      "rank": 220,
      "count": 356337
    },
    {
      "playerId": "sleeper-13276",
      "sleeperId": "13276",
      "name": "Omar Cooper Jr.",
      "team": "NYJ",
      "position": "WR",
      "rank": 162,
      "count": 297400
    },
    {
      "playerId": "sleeper-4881",
      "sleeperId": "4881",
      "name": "4881",
      "team": null,
      "position": null,
      "rank": null,
      "count": 295576
    },
    {
      "playerId": "sleeper-CLE",
      "sleeperId": "CLE",
      "name": "CLE",
      "team": null,
      "position": null,
      "rank": null,
      "count": 276416
    },
    {
      "playerId": "sleeper-4454",
      "sleeperId": "4454",
      "name": "4454",
      "team": null,
      "position": null,
      "rank": null,
      "count": 261543
    },
    {
      "playerId": "sleeper-1945",
      "sleeperId": "1945",
      "name": "Chris Boswell",
      "team": "PIT",
      "position": "K",
      "rank": 161,
      "count": 255096
    },
    {
      "playerId": "sleeper-12718",
      "sleeperId": "12718",
      "name": "12718",
      "team": null,
      "position": null,
      "rank": null,
      "count": 249642
    },
    {
      "playerId": "sleeper-5012",
      "sleeperId": "5012",
      "name": "Mark Andrews",
      "team": "BAL",
      "position": "TE",
      "rank": 107,
      "count": 245034
    },
    {
      "playerId": "sleeper-9480",
      "sleeperId": "9480",
      "name": "Brenton Strange",
      "team": "JAX",
      "position": "TE",
      "rank": 115,
      "count": 223254
    },
    {
      "playerId": "sleeper-5849",
      "sleeperId": "5849",
      "name": "Kyler Murray",
      "team": "MIN",
      "position": "QB",
      "rank": 97,
      "count": 213984
    },
    {
      "playerId": "sleeper-8129",
      "sleeperId": "8129",
      "name": "8129",
      "team": null,
      "position": null,
      "rank": null,
      "count": 212528
    },
    {
      "playerId": "sleeper-4037",
      "sleeperId": "4037",
      "name": "Chris Godwin Jr.",
      "team": "TB",
      "position": "WR",
      "rank": 98,
      "count": 203070
    },
    {
      "playerId": "sleeper-TB",
      "sleeperId": "TB",
      "name": "TB",
      "team": null,
      "position": null,
      "rank": null,
      "count": 194570
    },
    {
      "playerId": "sleeper-10235",
      "sleeperId": "10235",
      "name": "10235",
      "team": null,
      "position": null,
      "rank": null,
      "count": 192136
    },
    {
      "playerId": "sleeper-11581",
      "sleeperId": "11581",
      "name": "MarShawn Lloyd",
      "team": "GB",
      "position": "RB",
      "rank": 110,
      "count": 181854
    },
    {
      "playerId": "sleeper-12457",
      "sleeperId": "12457",
      "name": "Jaydon Blue",
      "team": "PHI",
      "position": "RB",
      "rank": 200,
      "count": 179888
    },
    {
      "playerId": "sleeper-7561",
      "sleeperId": "7561",
      "name": "7561",
      "team": null,
      "position": null,
      "rank": null,
      "count": 171081
    },
    {
      "playerId": "sleeper-PIT",
      "sleeperId": "PIT",
      "name": "PIT",
      "team": null,
      "position": null,
      "rank": null,
      "count": 169071
    },
    {
      "playerId": "sleeper-13150",
      "sleeperId": "13150",
      "name": "13150",
      "team": null,
      "position": null,
      "rank": null,
      "count": 166341
    },
    {
      "playerId": "sleeper-4147",
      "sleeperId": "4147",
      "name": "Samaje Perine",
      "team": "CIN",
      "position": "RB",
      "rank": 285,
      "count": 161940
    }
  ]
};

export const playerRankMovements = {
  "risers": [
    {
      "playerId": "sleeper-9482",
      "name": "Michael Mayer",
      "team": "LV",
      "position": "TE",
      "rank": 273,
      "previousRank": 287,
      "rankMovement": 14
    },
    {
      "playerId": "sleeper-4046",
      "name": "Patrick Mahomes",
      "team": "KC",
      "position": "QB",
      "rank": 46,
      "previousRank": 50,
      "rankMovement": 4
    },
    {
      "playerId": "sleeper-7021",
      "name": "Rico Dowdle",
      "team": "PIT",
      "position": "RB",
      "rank": 74,
      "previousRank": 78,
      "rankMovement": 4
    },
    {
      "playerId": "sleeper-11620",
      "name": "Rome Odunze",
      "team": "CHI",
      "position": "WR",
      "rank": 75,
      "previousRank": 79,
      "rankMovement": 4
    },
    {
      "playerId": "sleeper-1466",
      "name": "Travis Kelce",
      "team": "KC",
      "position": "TE",
      "rank": 100,
      "previousRank": 104,
      "rankMovement": 4
    },
    {
      "playerId": "sleeper-13413",
      "name": "Cyrus Allen",
      "team": "KC",
      "position": "WR",
      "rank": 189,
      "previousRank": 193,
      "rankMovement": 4
    },
    {
      "playerId": "sleeper-7571",
      "name": "Rashod Bateman",
      "team": "BAL",
      "position": "WR",
      "rank": 218,
      "previousRank": 222,
      "rankMovement": 4
    },
    {
      "playerId": "sleeper-13533",
      "name": "Barion Brown",
      "team": "NO",
      "position": "WR",
      "rank": 286,
      "previousRank": 290,
      "rankMovement": 4
    }
  ],
  "fallers": [
    {
      "playerId": "sleeper-421",
      "name": "Matthew Stafford",
      "team": "LAR",
      "position": "QB",
      "rank": 77,
      "previousRank": 74,
      "rankMovement": -3
    },
    {
      "playerId": "sleeper-4147",
      "name": "Samaje Perine",
      "team": "CIN",
      "position": "RB",
      "rank": 285,
      "previousRank": 284,
      "rankMovement": -1
    }
  ]
};

export const playerStatsById = {
  "sleeper-9509": {
    "season": "2024",
    "games": 17,
    "team": "ATL",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 304,
      "rushingYards": 1456,
      "rushingTds": 14,
      "receptions": 61,
      "targets": 72,
      "receivingYards": 431,
      "receivingTds": 1,
      "fantasyPoints": 280.7,
      "fantasyPointsPpr": 341.7,
      "totalYards": 1887,
      "totalTds": 15
    },
    "perGame": {
      "fantasyPoints": 16.5,
      "fantasyPointsPpr": 20.1,
      "totalYards": 111,
      "totalTds": 0.88,
      "receptions": 3.6,
      "targets": 4.2,
      "passingYards": 0,
      "rushingYards": 85.6,
      "receivingYards": 25.4
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 31.3,
      "totalYards": 173,
      "totalTds": 2,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 170,
      "receivingYards": 3
    }
  },
  "sleeper-9221": {
    "season": "2024",
    "games": 18,
    "team": "DET",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 264,
      "rushingYards": 1517,
      "rushingTds": 18,
      "receptions": 58,
      "targets": 74,
      "receivingYards": 567,
      "receivingTds": 3,
      "fantasyPoints": 332.4,
      "fantasyPointsPpr": 390.4,
      "totalYards": 2084,
      "totalTds": 21
    },
    "perGame": {
      "fantasyPoints": 18.5,
      "fantasyPointsPpr": 21.7,
      "totalYards": 115.8,
      "totalTds": 1.17,
      "receptions": 3.2,
      "targets": 4.1,
      "passingYards": 0,
      "rushingYards": 84.3,
      "receivingYards": 31.5
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 46,
      "totalYards": 170,
      "totalTds": 4,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 139,
      "receivingYards": 31
    }
  },
  "sleeper-4984": {
    "season": "2024",
    "games": 19,
    "team": "BUF",
    "position": "QB",
    "totals": {
      "completions": 365,
      "attempts": 565,
      "passingYards": 4367,
      "passingTds": 32,
      "interceptions": 6,
      "carries": 131,
      "rushingYards": 636,
      "rushingTds": 14,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 438.3,
      "fantasyPointsPpr": 438.3,
      "totalYards": 5003,
      "totalTds": 46
    },
    "perGame": {
      "fantasyPoints": 23.1,
      "fantasyPointsPpr": 23.1,
      "totalYards": 263.3,
      "totalTds": 2.42,
      "receptions": 0,
      "targets": 0,
      "passingYards": 229.8,
      "rushingYards": 33.5,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 51.9,
      "totalYards": 424,
      "totalTds": 6,
      "receptions": 0,
      "passingYards": 342,
      "rushingYards": 82,
      "receivingYards": 0
    }
  },
  "sleeper-7564": {
    "season": "2024",
    "games": 17,
    "team": "CIN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 32,
      "rushingTds": 0,
      "receptions": 127,
      "targets": 175,
      "receivingYards": 1708,
      "receivingTds": 17,
      "fantasyPoints": 276,
      "fantasyPointsPpr": 403,
      "totalYards": 1740,
      "totalTds": 17
    },
    "perGame": {
      "fantasyPoints": 16.2,
      "fantasyPointsPpr": 23.7,
      "totalYards": 102.4,
      "totalTds": 1,
      "receptions": 7.5,
      "targets": 10.3,
      "passingYards": 0,
      "rushingYards": 1.9,
      "receivingYards": 100.5
    },
    "bestWeek": {
      "week": 10,
      "fantasyPointsPpr": 55.4,
      "totalYards": 264,
      "totalTds": 3,
      "receptions": 11,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 264
    }
  },
  "sleeper-4034": {
    "season": "2024",
    "games": 4,
    "team": "SF",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 50,
      "rushingYards": 202,
      "rushingTds": 0,
      "receptions": 15,
      "targets": 19,
      "receivingYards": 146,
      "receivingTds": 0,
      "fantasyPoints": 32.8,
      "fantasyPointsPpr": 47.8,
      "totalYards": 348,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 8.2,
      "fantasyPointsPpr": 11.9,
      "totalYards": 87,
      "totalTds": 0,
      "receptions": 3.8,
      "targets": 4.8,
      "passingYards": 0,
      "rushingYards": 50.5,
      "receivingYards": 36.5
    },
    "bestWeek": {
      "week": 10,
      "fantasyPointsPpr": 16.7,
      "totalYards": 107,
      "totalTds": 0,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 39,
      "receivingYards": 68
    }
  },
  "sleeper-6813": {
    "season": "2024",
    "games": 14,
    "team": "IND",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 303,
      "rushingYards": 1431,
      "rushingTds": 11,
      "receptions": 18,
      "targets": 31,
      "receivingYards": 136,
      "receivingTds": 1,
      "fantasyPoints": 228.7,
      "fantasyPointsPpr": 246.7,
      "totalYards": 1567,
      "totalTds": 12
    },
    "perGame": {
      "fantasyPoints": 16.3,
      "fantasyPointsPpr": 17.6,
      "totalYards": 111.9,
      "totalTds": 0.86,
      "receptions": 1.3,
      "targets": 2.2,
      "passingYards": 0,
      "rushingYards": 102.2,
      "receivingYards": 9.7
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 39.8,
      "totalYards": 218,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 218,
      "receivingYards": 0
    }
  },
  "sleeper-9493": {
    "season": "2024",
    "games": 13,
    "team": "LA",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 12,
      "rushingYards": 53,
      "rushingTds": 1,
      "receptions": 90,
      "targets": 129,
      "receivingYards": 1131,
      "receivingTds": 3,
      "fantasyPoints": 142.4,
      "fantasyPointsPpr": 232.4,
      "totalYards": 1184,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 11,
      "fantasyPointsPpr": 17.9,
      "totalYards": 91.1,
      "totalTds": 0.31,
      "receptions": 6.9,
      "targets": 9.9,
      "passingYards": 0,
      "rushingYards": 4.1,
      "receivingYards": 87
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 41.8,
      "totalYards": 178,
      "totalTds": 2,
      "receptions": 12,
      "passingYards": 0,
      "rushingYards": 16,
      "receivingYards": 162
    }
  },
  "sleeper-9488": {
    "season": "2024",
    "games": 17,
    "team": "SEA",
    "position": "WR",
    "totals": {
      "completions": 1,
      "attempts": 1,
      "passingYards": 35,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 5,
      "rushingYards": 26,
      "rushingTds": 0,
      "receptions": 100,
      "targets": 137,
      "receivingYards": 1130,
      "receivingTds": 6,
      "fantasyPoints": 153,
      "fantasyPointsPpr": 253,
      "totalYards": 1191,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 9,
      "fantasyPointsPpr": 14.9,
      "totalYards": 70.1,
      "totalTds": 0.35,
      "receptions": 5.9,
      "targets": 8.1,
      "passingYards": 2.1,
      "rushingYards": 1.5,
      "receivingYards": 66.5
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 37,
      "totalYards": 180,
      "totalTds": 2,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 180
    }
  },
  "sleeper-3198": {
    "season": "2024",
    "games": 19,
    "team": "BAL",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 367,
      "rushingYards": 2191,
      "rushingTds": 19,
      "receptions": 19,
      "targets": 24,
      "receivingYards": 193,
      "receivingTds": 2,
      "fantasyPoints": 362.4,
      "fantasyPointsPpr": 381.4,
      "totalYards": 2384,
      "totalTds": 21
    },
    "perGame": {
      "fantasyPoints": 19.1,
      "fantasyPointsPpr": 20.1,
      "totalYards": 125.5,
      "totalTds": 1.11,
      "receptions": 1,
      "targets": 1.3,
      "passingYards": 0,
      "rushingYards": 115.3,
      "receivingYards": 10.2
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 35.9,
      "totalYards": 209,
      "totalTds": 2,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 199,
      "receivingYards": 10
    }
  },
  "sleeper-7547": {
    "season": "2024",
    "games": 18,
    "team": "DET",
    "position": "WR",
    "totals": {
      "completions": 1,
      "attempts": 1,
      "passingYards": 7,
      "passingTds": 1,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 6,
      "rushingTds": 0,
      "receptions": 123,
      "targets": 151,
      "receivingYards": 1400,
      "receivingTds": 12,
      "fantasyPoints": 214.9,
      "fantasyPointsPpr": 337.9,
      "totalYards": 1413,
      "totalTds": 13
    },
    "perGame": {
      "fantasyPoints": 11.9,
      "fantasyPointsPpr": 18.8,
      "totalYards": 78.5,
      "totalTds": 0.72,
      "receptions": 6.8,
      "targets": 8.4,
      "passingYards": 0.4,
      "rushingYards": 0.3,
      "receivingYards": 77.8
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 38.7,
      "totalYards": 157,
      "totalTds": 2,
      "receptions": 11,
      "passingYards": 0,
      "rushingYards": -4,
      "receivingYards": 161
    }
  },
  "sleeper-4866": {
    "season": "2024",
    "games": 20,
    "team": "PHI",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 436,
      "rushingYards": 2504,
      "rushingTds": 18,
      "receptions": 46,
      "targets": 58,
      "receivingYards": 353,
      "receivingTds": 2,
      "fantasyPoints": 409.7,
      "fantasyPointsPpr": 455.7,
      "totalYards": 2857,
      "totalTds": 20
    },
    "perGame": {
      "fantasyPoints": 20.5,
      "fantasyPointsPpr": 22.8,
      "totalYards": 142.8,
      "totalTds": 1,
      "receptions": 2.3,
      "targets": 2.9,
      "passingYards": 0,
      "rushingYards": 125.2,
      "receivingYards": 17.6
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 46.2,
      "totalYards": 302,
      "totalTds": 2,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 255,
      "receivingYards": 47
    }
  },
  "sleeper-6786": {
    "season": "2024",
    "games": 15,
    "team": "DAL",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 14,
      "rushingYards": 70,
      "rushingTds": 0,
      "receptions": 101,
      "targets": 152,
      "receivingYards": 1194,
      "receivingTds": 6,
      "fantasyPoints": 162.4,
      "fantasyPointsPpr": 263.4,
      "totalYards": 1264,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 10.8,
      "fantasyPointsPpr": 17.6,
      "totalYards": 84.3,
      "totalTds": 0.4,
      "receptions": 6.7,
      "targets": 10.1,
      "passingYards": 0,
      "rushingYards": 4.7,
      "receivingYards": 79.6
    },
    "bestWeek": {
      "week": 8,
      "fantasyPointsPpr": 39.6,
      "totalYards": 146,
      "totalTds": 2,
      "receptions": 13,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 146
    }
  },
  "sleeper-11564": {
    "season": "2024",
    "games": 13,
    "team": "NE",
    "position": "QB",
    "totals": {
      "completions": 225,
      "attempts": 338,
      "passingYards": 2276,
      "passingTds": 15,
      "interceptions": 10,
      "carries": 54,
      "rushingYards": 421,
      "rushingTds": 2,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 177.1,
      "fantasyPointsPpr": 177.1,
      "totalYards": 2697,
      "totalTds": 17
    },
    "perGame": {
      "fantasyPoints": 13.6,
      "fantasyPointsPpr": 13.6,
      "totalYards": 207.5,
      "totalTds": 1.31,
      "receptions": 0,
      "targets": 0,
      "passingYards": 175.1,
      "rushingYards": 32.4,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 20.8,
      "totalYards": 294,
      "totalTds": 2,
      "receptions": 0,
      "passingYards": 276,
      "rushingYards": 18,
      "receivingYards": 0
    }
  },
  "sleeper-6794": {
    "season": "2024",
    "games": 18,
    "team": "MIN",
    "position": "WR",
    "totals": {
      "completions": 1,
      "attempts": 1,
      "passingYards": 22,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 3,
      "rushingTds": 0,
      "receptions": 108,
      "targets": 162,
      "receivingYards": 1591,
      "receivingTds": 10,
      "fantasyPoints": 220.3,
      "fantasyPointsPpr": 328.3,
      "totalYards": 1616,
      "totalTds": 10
    },
    "perGame": {
      "fantasyPoints": 12.2,
      "fantasyPointsPpr": 18.2,
      "totalYards": 89.8,
      "totalTds": 0.56,
      "receptions": 6,
      "targets": 9,
      "passingYards": 1.2,
      "rushingYards": 0.2,
      "receivingYards": 88.4
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 36.4,
      "totalYards": 144,
      "totalTds": 2,
      "receptions": 10,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 144
    }
  },
  "sleeper-8150": {
    "season": "2024",
    "games": 18,
    "team": "LA",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 351,
      "rushingYards": 1481,
      "rushingTds": 14,
      "receptions": 38,
      "targets": 45,
      "receivingYards": 197,
      "receivingTds": 3,
      "fantasyPoints": 261.8,
      "fantasyPointsPpr": 299.8,
      "totalYards": 1678,
      "totalTds": 17
    },
    "perGame": {
      "fantasyPoints": 14.5,
      "fantasyPointsPpr": 16.7,
      "totalYards": 93.2,
      "totalTds": 0.94,
      "receptions": 2.1,
      "targets": 2.5,
      "passingYards": 0,
      "rushingYards": 82.3,
      "receivingYards": 10.9
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 31.6,
      "totalYards": 116,
      "totalTds": 3,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 89,
      "receivingYards": 27
    }
  },
  "sleeper-9224": {
    "season": "2024",
    "games": 16,
    "team": "CIN",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 229,
      "rushingYards": 990,
      "rushingTds": 7,
      "receptions": 54,
      "targets": 65,
      "receivingYards": 360,
      "receivingTds": 4,
      "fantasyPoints": 201,
      "fantasyPointsPpr": 255,
      "totalYards": 1350,
      "totalTds": 11
    },
    "perGame": {
      "fantasyPoints": 12.6,
      "fantasyPointsPpr": 15.9,
      "totalYards": 84.4,
      "totalTds": 0.69,
      "receptions": 3.4,
      "targets": 4.1,
      "passingYards": 0,
      "rushingYards": 61.9,
      "receivingYards": 22.5
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 26.7,
      "totalYards": 157,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 120,
      "receivingYards": 37
    }
  },
  "sleeper-6770": {
    "season": "2024",
    "games": 17,
    "team": "CIN",
    "position": "QB",
    "totals": {
      "completions": 460,
      "attempts": 652,
      "passingYards": 4918,
      "passingTds": 43,
      "interceptions": 9,
      "carries": 42,
      "rushingYards": 201,
      "rushingTds": 2,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 372.8,
      "fantasyPointsPpr": 372.8,
      "totalYards": 5119,
      "totalTds": 45
    },
    "perGame": {
      "fantasyPoints": 21.9,
      "fantasyPointsPpr": 21.9,
      "totalYards": 301.1,
      "totalTds": 2.65,
      "receptions": 0,
      "targets": 0,
      "passingYards": 289.3,
      "rushingYards": 11.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 37,
      "totalYards": 437,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 412,
      "rushingYards": 25,
      "receivingYards": 0
    }
  },
  "sleeper-5859": {
    "season": "2024",
    "games": 17,
    "team": "PHI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 79,
      "targets": 120,
      "receivingYards": 1242,
      "receivingTds": 9,
      "fantasyPoints": 178.2,
      "fantasyPointsPpr": 257.2,
      "totalYards": 1242,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 10.5,
      "fantasyPointsPpr": 15.1,
      "totalYards": 73.1,
      "totalTds": 0.53,
      "receptions": 4.6,
      "targets": 7.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 73.1
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 25,
      "totalYards": 110,
      "totalTds": 1,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 110
    }
  },
  "sleeper-8112": {
    "season": "2024",
    "games": 17,
    "team": "ATL",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": -3,
      "rushingTds": 0,
      "receptions": 100,
      "targets": 158,
      "receivingYards": 1271,
      "receivingTds": 9,
      "fantasyPoints": 180.8,
      "fantasyPointsPpr": 280.8,
      "totalYards": 1268,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 10.6,
      "fantasyPointsPpr": 16.5,
      "totalYards": 74.6,
      "totalTds": 0.53,
      "receptions": 5.9,
      "targets": 9.3,
      "passingYards": 0,
      "rushingYards": -0.2,
      "receivingYards": 74.8
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 40.7,
      "totalYards": 187,
      "totalTds": 2,
      "receptions": 10,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 187
    }
  },
  "sleeper-5850": {
    "season": "2024",
    "games": 18,
    "team": "GB",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 319,
      "rushingYards": 1410,
      "rushingTds": 16,
      "receptions": 39,
      "targets": 46,
      "receivingYards": 382,
      "receivingTds": 1,
      "fantasyPoints": 275.2,
      "fantasyPointsPpr": 314.2,
      "totalYards": 1792,
      "totalTds": 17
    },
    "perGame": {
      "fantasyPoints": 15.3,
      "fantasyPointsPpr": 17.5,
      "totalYards": 99.6,
      "totalTds": 0.94,
      "receptions": 2.2,
      "targets": 2.6,
      "passingYards": 0,
      "rushingYards": 78.3,
      "receivingYards": 21.2
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 28.6,
      "totalYards": 106,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 106,
      "receivingYards": 0
    }
  },
  "sleeper-11604": {
    "season": "2024",
    "games": 17,
    "team": "LV",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 5,
      "rushingYards": 13,
      "rushingTds": 0,
      "receptions": 112,
      "targets": 153,
      "receivingYards": 1194,
      "receivingTds": 5,
      "fantasyPoints": 150.7,
      "fantasyPointsPpr": 262.7,
      "totalYards": 1207,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 8.9,
      "fantasyPointsPpr": 15.5,
      "totalYards": 71,
      "totalTds": 0.29,
      "receptions": 6.6,
      "targets": 9,
      "passingYards": 0,
      "rushingYards": 0.8,
      "receivingYards": 70.2
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 31.3,
      "totalYards": 123,
      "totalTds": 1,
      "receptions": 13,
      "passingYards": 0,
      "rushingYards": -3,
      "receivingYards": 126
    }
  },
  "sleeper-11560": {
    "season": "2024",
    "games": 17,
    "team": "CHI",
    "position": "QB",
    "totals": {
      "completions": 351,
      "attempts": 562,
      "passingYards": 3541,
      "passingTds": 20,
      "interceptions": 6,
      "carries": 81,
      "rushingYards": 489,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 254.5,
      "fantasyPointsPpr": 254.5,
      "totalYards": 4030,
      "totalTds": 20
    },
    "perGame": {
      "fantasyPoints": 15,
      "fantasyPointsPpr": 15,
      "totalYards": 237.1,
      "totalTds": 1.18,
      "receptions": 0,
      "targets": 0,
      "passingYards": 208.3,
      "rushingYards": 28.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 28.6,
      "totalYards": 282,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 226,
      "rushingYards": 56,
      "receivingYards": 0
    }
  },
  "sleeper-8130": {
    "season": "2024",
    "games": 16,
    "team": "ARI",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 2,
      "rushingTds": 1,
      "receptions": 111,
      "targets": 147,
      "receivingYards": 1146,
      "receivingTds": 2,
      "fantasyPoints": 132.8,
      "fantasyPointsPpr": 243.8,
      "totalYards": 1148,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 8.3,
      "fantasyPointsPpr": 15.2,
      "totalYards": 71.8,
      "totalTds": 0.19,
      "receptions": 6.9,
      "targets": 9.2,
      "passingYards": 0,
      "rushingYards": 0.1,
      "receivingYards": 71.6
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 30.3,
      "totalYards": 123,
      "totalTds": 1,
      "receptions": 12,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 123
    }
  },
  "sleeper-11566": {
    "season": "2024",
    "games": 20,
    "team": "WAS",
    "position": "QB",
    "totals": {
      "completions": 406,
      "attempts": 594,
      "passingYards": 4390,
      "passingTds": 30,
      "interceptions": 10,
      "carries": 183,
      "rushingYards": 1026,
      "rushingTds": 7,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 428.2,
      "fantasyPointsPpr": 428.2,
      "totalYards": 5416,
      "totalTds": 37
    },
    "perGame": {
      "fantasyPoints": 21.4,
      "fantasyPointsPpr": 21.4,
      "totalYards": 270.8,
      "totalTds": 1.85,
      "receptions": 0,
      "targets": 0,
      "passingYards": 219.5,
      "rushingYards": 51.3,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 34.4,
      "totalYards": 339,
      "totalTds": 5,
      "receptions": 0,
      "passingYards": 258,
      "rushingYards": 81,
      "receivingYards": 0
    }
  },
  "sleeper-7569": {
    "season": "2024",
    "games": 14,
    "team": "HOU",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 80,
      "targets": 115,
      "receivingYards": 1209,
      "receivingTds": 8,
      "fantasyPoints": 168.9,
      "fantasyPointsPpr": 248.9,
      "totalYards": 1209,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 12.1,
      "fantasyPointsPpr": 17.8,
      "totalYards": 86.4,
      "totalTds": 0.57,
      "receptions": 5.7,
      "targets": 8.2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 86.4
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 33.1,
      "totalYards": 151,
      "totalTds": 1,
      "receptions": 12,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 151
    }
  },
  "sleeper-8137": {
    "season": "2024",
    "games": 15,
    "team": "PIT",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": -6,
      "rushingTds": 0,
      "receptions": 64,
      "targets": 108,
      "receivingYards": 987,
      "receivingTds": 4,
      "fantasyPoints": 120.1,
      "fantasyPointsPpr": 184.1,
      "totalYards": 981,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 8,
      "fantasyPointsPpr": 12.3,
      "totalYards": 65.4,
      "totalTds": 0.27,
      "receptions": 4.3,
      "targets": 7.2,
      "passingYards": 0,
      "rushingYards": -0.4,
      "receivingYards": 65.8
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 22.1,
      "totalYards": 111,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 111
    }
  },
  "sleeper-8155": {
    "season": "2024",
    "games": 16,
    "team": "NYJ",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 209,
      "rushingYards": 876,
      "rushingTds": 5,
      "receptions": 57,
      "targets": 76,
      "receivingYards": 483,
      "receivingTds": 3,
      "fantasyPoints": 183.9,
      "fantasyPointsPpr": 240.9,
      "totalYards": 1359,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 11.5,
      "fantasyPointsPpr": 15.1,
      "totalYards": 84.9,
      "totalTds": 0.5,
      "receptions": 3.6,
      "targets": 4.8,
      "passingYards": 0,
      "rushingYards": 54.8,
      "receivingYards": 30.2
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 31.1,
      "totalYards": 121,
      "totalTds": 2,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 78,
      "receivingYards": 43
    }
  },
  "sleeper-11632": {
    "season": "2024",
    "games": 15,
    "team": "NYG",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 1,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 5,
      "rushingYards": 2,
      "rushingTds": 0,
      "receptions": 109,
      "targets": 170,
      "receivingYards": 1204,
      "receivingTds": 7,
      "fantasyPoints": 164.6,
      "fantasyPointsPpr": 273.6,
      "totalYards": 1206,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 11,
      "fantasyPointsPpr": 18.2,
      "totalYards": 80.4,
      "totalTds": 0.47,
      "receptions": 7.3,
      "targets": 11.3,
      "passingYards": 0,
      "rushingYards": 0.1,
      "receivingYards": 80.3
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 36.1,
      "totalYards": 171,
      "totalTds": 2,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 171
    }
  },
  "sleeper-8144": {
    "season": "2024",
    "games": 8,
    "team": "NO",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 7,
      "rushingTds": 0,
      "receptions": 32,
      "targets": 44,
      "receivingYards": 400,
      "receivingTds": 1,
      "fantasyPoints": 44.7,
      "fantasyPointsPpr": 76.7,
      "totalYards": 407,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 5.6,
      "fantasyPointsPpr": 9.6,
      "totalYards": 50.9,
      "totalTds": 0.13,
      "receptions": 4,
      "targets": 5.5,
      "passingYards": 0,
      "rushingYards": 0.9,
      "receivingYards": 50
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 20.6,
      "totalYards": 86,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 86
    }
  },
  "sleeper-10229": {
    "season": "2024",
    "games": 3,
    "team": "KC",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 1,
      "rushingTds": 0,
      "receptions": 24,
      "targets": 29,
      "receivingYards": 288,
      "receivingTds": 2,
      "fantasyPoints": 40.9,
      "fantasyPointsPpr": 64.9,
      "totalYards": 289,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 13.6,
      "fantasyPointsPpr": 21.6,
      "totalYards": 96.3,
      "totalTds": 0.67,
      "receptions": 8,
      "targets": 9.7,
      "passingYards": 0,
      "rushingYards": 0.3,
      "receivingYards": 96
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 29.1,
      "totalYards": 111,
      "totalTds": 1,
      "receptions": 12,
      "passingYards": 0,
      "rushingYards": 1,
      "receivingYards": 110
    }
  },
  "sleeper-7588": {
    "season": "2024",
    "games": 18,
    "team": "DEN",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 146,
      "rushingYards": 542,
      "rushingTds": 4,
      "receptions": 54,
      "targets": 72,
      "receivingYards": 360,
      "receivingTds": 0,
      "fantasyPoints": 110.2,
      "fantasyPointsPpr": 164.2,
      "totalYards": 902,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 6.1,
      "fantasyPointsPpr": 9.1,
      "totalYards": 50.1,
      "totalTds": 0.22,
      "receptions": 3,
      "targets": 4,
      "passingYards": 0,
      "rushingYards": 30.1,
      "receivingYards": 20
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 26.1,
      "totalYards": 111,
      "totalTds": 2,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 88,
      "receivingYards": 23
    }
  },
  "sleeper-11584": {
    "season": "2024",
    "games": 18,
    "team": "TB",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 224,
      "rushingYards": 1199,
      "rushingTds": 8,
      "receptions": 49,
      "targets": 54,
      "receivingYards": 398,
      "receivingTds": 1,
      "fantasyPoints": 211.7,
      "fantasyPointsPpr": 260.7,
      "totalYards": 1597,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 11.8,
      "fantasyPointsPpr": 14.5,
      "totalYards": 88.7,
      "totalTds": 0.5,
      "receptions": 2.7,
      "targets": 3,
      "passingYards": 0,
      "rushingYards": 66.6,
      "receivingYards": 22.1
    },
    "bestWeek": {
      "week": 13,
      "fantasyPointsPpr": 27.5,
      "totalYards": 185,
      "totalTds": 1,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 152,
      "receivingYards": 33
    }
  },
  "sleeper-6797": {
    "season": "2024",
    "games": 18,
    "team": "LAC",
    "position": "QB",
    "totals": {
      "completions": 346,
      "attempts": 536,
      "passingYards": 4112,
      "passingTds": 24,
      "interceptions": 7,
      "carries": 69,
      "rushingYards": 306,
      "rushingTds": 2,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 291.1,
      "fantasyPointsPpr": 291.1,
      "totalYards": 4418,
      "totalTds": 26
    },
    "perGame": {
      "fantasyPoints": 16.2,
      "fantasyPointsPpr": 16.2,
      "totalYards": 245.4,
      "totalTds": 1.44,
      "receptions": 0,
      "targets": 0,
      "passingYards": 228.4,
      "rushingYards": 17,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 28,
      "totalYards": 388,
      "totalTds": 2,
      "receptions": 0,
      "passingYards": 346,
      "rushingYards": 42,
      "receivingYards": 0
    }
  },
  "sleeper-7525": {
    "season": "2024",
    "games": 17,
    "team": "PHI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 1,
      "rushingTds": 0,
      "receptions": 84,
      "targets": 106,
      "receivingYards": 1023,
      "receivingTds": 9,
      "fantasyPoints": 156.4,
      "fantasyPointsPpr": 240.4,
      "totalYards": 1024,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 9.2,
      "fantasyPointsPpr": 14.1,
      "totalYards": 60.2,
      "totalTds": 0.53,
      "receptions": 4.9,
      "targets": 6.2,
      "passingYards": 0,
      "rushingYards": 0.1,
      "receivingYards": 60.2
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 30,
      "totalYards": 120,
      "totalTds": 2,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 120
    }
  },
  "sleeper-11635": {
    "season": "2024",
    "games": 17,
    "team": "LAC",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 91,
      "targets": 126,
      "receivingYards": 1346,
      "receivingTds": 8,
      "fantasyPoints": 184.6,
      "fantasyPointsPpr": 275.6,
      "totalYards": 1346,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 10.9,
      "fantasyPointsPpr": 16.2,
      "totalYards": 79.2,
      "totalTds": 0.47,
      "receptions": 5.4,
      "targets": 7.4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 79.2
    },
    "bestWeek": {
      "week": 19,
      "fantasyPointsPpr": 34.7,
      "totalYards": 197,
      "totalTds": 1,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 197
    }
  },
  "sleeper-6801": {
    "season": "2024",
    "games": 12,
    "team": "CIN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 73,
      "targets": 109,
      "receivingYards": 911,
      "receivingTds": 10,
      "fantasyPoints": 149.1,
      "fantasyPointsPpr": 222.1,
      "totalYards": 911,
      "totalTds": 10
    },
    "perGame": {
      "fantasyPoints": 12.4,
      "fantasyPointsPpr": 18.5,
      "totalYards": 75.9,
      "totalTds": 0.83,
      "receptions": 6.1,
      "targets": 9.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 75.9
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 40.1,
      "totalYards": 131,
      "totalTds": 3,
      "receptions": 11,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 131
    }
  },
  "sleeper-8146": {
    "season": "2024",
    "games": 17,
    "team": "NYJ",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 5,
      "rushingTds": 0,
      "receptions": 101,
      "targets": 153,
      "receivingYards": 1104,
      "receivingTds": 7,
      "fantasyPoints": 150.9,
      "fantasyPointsPpr": 251.9,
      "totalYards": 1109,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 8.9,
      "fantasyPointsPpr": 14.8,
      "totalYards": 65.2,
      "totalTds": 0.41,
      "receptions": 5.9,
      "targets": 9,
      "passingYards": 0,
      "rushingYards": 0.3,
      "receivingYards": 64.9
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 30,
      "totalYards": 90,
      "totalTds": 2,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 90
    }
  },
  "sleeper-3294": {
    "season": "2024",
    "games": 8,
    "team": "DAL",
    "position": "QB",
    "totals": {
      "completions": 185,
      "attempts": 286,
      "passingYards": 1978,
      "passingTds": 11,
      "interceptions": 8,
      "carries": 13,
      "rushingYards": 54,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 116.5,
      "fantasyPointsPpr": 116.5,
      "totalYards": 2032,
      "totalTds": 12
    },
    "perGame": {
      "fantasyPoints": 14.6,
      "fantasyPointsPpr": 14.6,
      "totalYards": 254,
      "totalTds": 1.5,
      "receptions": 0,
      "targets": 0,
      "passingYards": 247.3,
      "rushingYards": 6.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 29.9,
      "totalYards": 386,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 379,
      "rushingYards": 7,
      "receivingYards": 0
    }
  },
  "sleeper-4046": {
    "season": "2024",
    "games": 19,
    "team": "KC",
    "position": "QB",
    "totals": {
      "completions": 447,
      "attempts": 664,
      "passingYards": 4607,
      "passingTds": 31,
      "interceptions": 13,
      "carries": 80,
      "rushingYards": 389,
      "rushingTds": 4,
      "receptions": 1,
      "targets": 1,
      "receivingYards": 2,
      "receivingTds": 0,
      "fantasyPoints": 347.4,
      "fantasyPointsPpr": 348.4,
      "totalYards": 4998,
      "totalTds": 35
    },
    "perGame": {
      "fantasyPoints": 18.3,
      "fantasyPointsPpr": 18.3,
      "totalYards": 263.1,
      "totalTds": 1.84,
      "receptions": 0.1,
      "targets": 0.1,
      "passingYards": 242.5,
      "rushingYards": 20.5,
      "receivingYards": 0.1
    },
    "bestWeek": {
      "week": 21,
      "fantasyPointsPpr": 30.1,
      "totalYards": 288,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 245,
      "rushingYards": 43,
      "receivingYards": 0
    }
  },
  "sleeper-9997": {
    "season": "2024",
    "games": 17,
    "team": "BAL",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 9,
      "rushingYards": 56,
      "rushingTds": 0,
      "receptions": 74,
      "targets": 116,
      "receivingYards": 1059,
      "receivingTds": 4,
      "fantasyPoints": 135.5,
      "fantasyPointsPpr": 209.5,
      "totalYards": 1115,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 8,
      "fantasyPointsPpr": 12.3,
      "totalYards": 65.6,
      "totalTds": 0.24,
      "receptions": 4.4,
      "targets": 6.8,
      "passingYards": 0,
      "rushingYards": 3.3,
      "receivingYards": 62.3
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 29.7,
      "totalYards": 127,
      "totalTds": 2,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 127
    }
  },
  "sleeper-5892": {
    "season": "2024",
    "games": 15,
    "team": "DET",
    "position": "RB",
    "totals": {
      "completions": 2,
      "attempts": 2,
      "passingYards": 23,
      "passingTds": 1,
      "interceptions": 0,
      "carries": 192,
      "rushingYards": 803,
      "rushingTds": 12,
      "receptions": 36,
      "targets": 38,
      "receivingYards": 341,
      "receivingTds": 0,
      "fantasyPoints": 189.3,
      "fantasyPointsPpr": 225.3,
      "totalYards": 1167,
      "totalTds": 13
    },
    "perGame": {
      "fantasyPoints": 12.6,
      "fantasyPointsPpr": 15,
      "totalYards": 77.8,
      "totalTds": 0.87,
      "receptions": 2.4,
      "targets": 2.5,
      "passingYards": 1.5,
      "rushingYards": 53.5,
      "receivingYards": 22.7
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 24.5,
      "totalYards": 95,
      "totalTds": 2,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 75,
      "receivingYards": 20
    }
  },
  "sleeper-7523": {
    "season": "2024",
    "games": 10,
    "team": "JAX",
    "position": "QB",
    "totals": {
      "completions": 172,
      "attempts": 284,
      "passingYards": 2045,
      "passingTds": 11,
      "interceptions": 7,
      "carries": 26,
      "rushingYards": 119,
      "rushingTds": 3,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 145.7,
      "fantasyPointsPpr": 145.7,
      "totalYards": 2164,
      "totalTds": 14
    },
    "perGame": {
      "fantasyPoints": 14.6,
      "fantasyPointsPpr": 14.6,
      "totalYards": 216.4,
      "totalTds": 1.4,
      "receptions": 0,
      "targets": 0,
      "passingYards": 204.5,
      "rushingYards": 11.9,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 8,
      "fantasyPointsPpr": 23.3,
      "totalYards": 318,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 308,
      "rushingYards": 10,
      "receivingYards": 0
    }
  },
  "sleeper-7526": {
    "season": "2024",
    "games": 15,
    "team": "MIA",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 4,
      "rushingYards": 12,
      "rushingTds": 0,
      "receptions": 58,
      "targets": 83,
      "receivingYards": 744,
      "receivingTds": 2,
      "fantasyPoints": 91.6,
      "fantasyPointsPpr": 149.6,
      "totalYards": 756,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 6.1,
      "fantasyPointsPpr": 10,
      "totalYards": 50.4,
      "totalTds": 0.13,
      "receptions": 3.9,
      "targets": 5.5,
      "passingYards": 0,
      "rushingYards": 0.8,
      "receivingYards": 49.6
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 28.4,
      "totalYards": 144,
      "totalTds": 1,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 144
    }
  },
  "sleeper-11563": {
    "season": "2024",
    "games": 18,
    "team": "DEN",
    "position": "QB",
    "totals": {
      "completions": 389,
      "attempts": 589,
      "passingYards": 3919,
      "passingTds": 30,
      "interceptions": 12,
      "carries": 96,
      "rushingYards": 473,
      "rushingTds": 4,
      "receptions": 1,
      "targets": 1,
      "receivingYards": 2,
      "receivingTds": 1,
      "fantasyPoints": 330.3,
      "fantasyPointsPpr": 331.3,
      "totalYards": 4394,
      "totalTds": 35
    },
    "perGame": {
      "fantasyPoints": 18.4,
      "fantasyPointsPpr": 18.4,
      "totalYards": 244.1,
      "totalTds": 1.94,
      "receptions": 0.1,
      "targets": 0.1,
      "passingYards": 217.7,
      "rushingYards": 26.3,
      "receivingYards": 0.1
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 33.5,
      "totalYards": 368,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 321,
      "rushingYards": 47,
      "receivingYards": 0
    }
  },
  "sleeper-6790": {
    "season": "2024",
    "games": 17,
    "team": "CHI",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 253,
      "rushingYards": 959,
      "rushingTds": 6,
      "receptions": 42,
      "targets": 52,
      "receivingYards": 386,
      "receivingTds": 0,
      "fantasyPoints": 172.5,
      "fantasyPointsPpr": 214.5,
      "totalYards": 1345,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 10.1,
      "fantasyPointsPpr": 12.6,
      "totalYards": 79.1,
      "totalTds": 0.35,
      "receptions": 2.5,
      "targets": 3.1,
      "passingYards": 0,
      "rushingYards": 56.4,
      "receivingYards": 22.7
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 29.5,
      "totalYards": 165,
      "totalTds": 1,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 93,
      "receivingYards": 72
    }
  },
  "sleeper-4983": {
    "season": "2024",
    "games": 17,
    "team": "CHI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 1,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 14,
      "rushingYards": 75,
      "rushingTds": 0,
      "receptions": 98,
      "targets": 140,
      "receivingYards": 966,
      "receivingTds": 6,
      "fantasyPoints": 140.1,
      "fantasyPointsPpr": 238.1,
      "totalYards": 1041,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 8.2,
      "fantasyPointsPpr": 14,
      "totalYards": 61.2,
      "totalTds": 0.35,
      "receptions": 5.8,
      "targets": 8.2,
      "passingYards": 0,
      "rushingYards": 4.4,
      "receivingYards": 56.8
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 27.5,
      "totalYards": 105,
      "totalTds": 2,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 105
    }
  },
  "sleeper-8228": {
    "season": "2024",
    "games": 16,
    "team": "PIT",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 122,
      "rushingYards": 517,
      "rushingTds": 1,
      "receptions": 42,
      "targets": 52,
      "receivingYards": 329,
      "receivingTds": 0,
      "fantasyPoints": 88.6,
      "fantasyPointsPpr": 130.6,
      "totalYards": 846,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 5.5,
      "fantasyPointsPpr": 8.2,
      "totalYards": 52.9,
      "totalTds": 0.06,
      "receptions": 2.6,
      "targets": 3.3,
      "passingYards": 0,
      "rushingYards": 32.3,
      "receivingYards": 20.6
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 16.2,
      "totalYards": 112,
      "totalTds": 0,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 71,
      "receivingYards": 41
    }
  },
  "sleeper-8148": {
    "season": "2024",
    "games": 16,
    "team": "DET",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 1,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 1,
      "carries": 12,
      "rushingYards": 122,
      "rushingTds": 2,
      "receptions": 59,
      "targets": 95,
      "receivingYards": 1020,
      "receivingTds": 7,
      "fantasyPoints": 166.2,
      "fantasyPointsPpr": 225.2,
      "totalYards": 1142,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 10.4,
      "fantasyPointsPpr": 14.1,
      "totalYards": 71.4,
      "totalTds": 0.56,
      "receptions": 3.7,
      "targets": 5.9,
      "passingYards": 0,
      "rushingYards": 7.6,
      "receivingYards": 63.8
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 26,
      "totalYards": 150,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 7,
      "receivingYards": 143
    }
  },
  "sleeper-8183": {
    "season": "2024",
    "games": 15,
    "team": "SF",
    "position": "QB",
    "totals": {
      "completions": 300,
      "attempts": 455,
      "passingYards": 3864,
      "passingTds": 20,
      "interceptions": 12,
      "carries": 66,
      "rushingYards": 323,
      "rushingTds": 5,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 266.9,
      "fantasyPointsPpr": 266.9,
      "totalYards": 4187,
      "totalTds": 25
    },
    "perGame": {
      "fantasyPoints": 17.8,
      "fantasyPointsPpr": 17.8,
      "totalYards": 279.1,
      "totalTds": 1.67,
      "receptions": 0,
      "targets": 0,
      "passingYards": 257.6,
      "rushingYards": 21.5,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 30.3,
      "totalYards": 389,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 377,
      "rushingYards": 12,
      "receivingYards": 0
    }
  },
  "sleeper-7611": {
    "season": "2024",
    "games": 15,
    "team": "NE",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 207,
      "rushingYards": 801,
      "rushingTds": 7,
      "receptions": 33,
      "targets": 41,
      "receivingYards": 168,
      "receivingTds": 1,
      "fantasyPoints": 142.9,
      "fantasyPointsPpr": 175.9,
      "totalYards": 969,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 9.5,
      "fantasyPointsPpr": 11.7,
      "totalYards": 64.6,
      "totalTds": 0.53,
      "receptions": 2.2,
      "targets": 2.7,
      "passingYards": 0,
      "rushingYards": 53.4,
      "receivingYards": 11.2
    },
    "bestWeek": {
      "week": 8,
      "fantasyPointsPpr": 23.5,
      "totalYards": 65,
      "totalTds": 2,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 48,
      "receivingYards": 17
    }
  },
  "sleeper-10859": {
    "season": "2024",
    "games": 17,
    "team": "DET",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 66,
      "targets": 90,
      "receivingYards": 777,
      "receivingTds": 8,
      "fantasyPoints": 125.7,
      "fantasyPointsPpr": 191.7,
      "totalYards": 777,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 7.4,
      "fantasyPointsPpr": 11.3,
      "totalYards": 45.7,
      "totalTds": 0.47,
      "receptions": 3.9,
      "targets": 5.3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 45.7
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 18.4,
      "totalYards": 64,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 64
    }
  },
  "sleeper-2216": {
    "season": "2024",
    "games": 15,
    "team": "TB",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 81,
      "targets": 117,
      "receivingYards": 1096,
      "receivingTds": 12,
      "fantasyPoints": 181.6,
      "fantasyPointsPpr": 262.6,
      "totalYards": 1096,
      "totalTds": 12
    },
    "perGame": {
      "fantasyPoints": 12.1,
      "fantasyPointsPpr": 17.5,
      "totalYards": 73.1,
      "totalTds": 0.8,
      "receptions": 5.4,
      "targets": 7.8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 73.1
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 36.9,
      "totalYards": 159,
      "totalTds": 2,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 159
    }
  },
  "sleeper-3163": {
    "season": "2024",
    "games": 18,
    "team": "DET",
    "position": "QB",
    "totals": {
      "completions": 413,
      "attempts": 579,
      "passingYards": 4942,
      "passingTds": 38,
      "interceptions": 15,
      "carries": 36,
      "rushingYards": 63,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 1,
      "receivingYards": 7,
      "receivingTds": 1,
      "fantasyPoints": 332.7,
      "fantasyPointsPpr": 333.7,
      "totalYards": 5012,
      "totalTds": 39
    },
    "perGame": {
      "fantasyPoints": 18.5,
      "fantasyPointsPpr": 18.5,
      "totalYards": 278.4,
      "totalTds": 2.17,
      "receptions": 0.1,
      "targets": 0.1,
      "passingYards": 274.6,
      "rushingYards": 3.5,
      "receivingYards": 0.4
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 41.1,
      "totalYards": 507,
      "totalTds": 5,
      "receptions": 0,
      "passingYards": 494,
      "rushingYards": 13,
      "receivingYards": 0
    }
  },
  "sleeper-5967": {
    "season": "2024",
    "games": 16,
    "team": "TEN",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 260,
      "rushingYards": 1079,
      "rushingTds": 5,
      "receptions": 41,
      "targets": 57,
      "receivingYards": 238,
      "receivingTds": 0,
      "fantasyPoints": 159.7,
      "fantasyPointsPpr": 200.7,
      "totalYards": 1317,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 10,
      "fantasyPointsPpr": 12.5,
      "totalYards": 82.3,
      "totalTds": 0.31,
      "receptions": 2.6,
      "targets": 3.6,
      "passingYards": 0,
      "rushingYards": 67.4,
      "receivingYards": 14.9
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 21.9,
      "totalYards": 129,
      "totalTds": 1,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 119,
      "receivingYards": 10
    }
  },
  "sleeper-8167": {
    "season": "2024",
    "games": 14,
    "team": "GB",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 4,
      "rushingYards": 23,
      "rushingTds": 0,
      "receptions": 29,
      "targets": 53,
      "receivingYards": 620,
      "receivingTds": 2,
      "fantasyPoints": 76.3,
      "fantasyPointsPpr": 105.3,
      "totalYards": 643,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 5.5,
      "fantasyPointsPpr": 7.5,
      "totalYards": 45.9,
      "totalTds": 0.14,
      "receptions": 2.1,
      "targets": 3.8,
      "passingYards": 0,
      "rushingYards": 1.6,
      "receivingYards": 44.3
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 19,
      "totalYards": 150,
      "totalTds": 0,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 150
    }
  },
  "sleeper-9484": {
    "season": "2024",
    "games": 18,
    "team": "GB",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 5,
      "rushingYards": 16,
      "rushingTds": 0,
      "receptions": 55,
      "targets": 75,
      "receivingYards": 733,
      "receivingTds": 7,
      "fantasyPoints": 116.9,
      "fantasyPointsPpr": 171.9,
      "totalYards": 749,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 6.5,
      "fantasyPointsPpr": 9.6,
      "totalYards": 41.6,
      "totalTds": 0.39,
      "receptions": 3.1,
      "targets": 4.2,
      "passingYards": 0,
      "rushingYards": 0.9,
      "receivingYards": 40.7
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 24.8,
      "totalYards": 88,
      "totalTds": 2,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 88
    }
  },
  "sleeper-7021": {
    "season": "2024",
    "games": 16,
    "team": "DAL",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 235,
      "rushingYards": 1079,
      "rushingTds": 2,
      "receptions": 39,
      "targets": 49,
      "receivingYards": 249,
      "receivingTds": 3,
      "fantasyPoints": 158.8,
      "fantasyPointsPpr": 197.8,
      "totalYards": 1328,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 9.9,
      "fantasyPointsPpr": 12.4,
      "totalYards": 83,
      "totalTds": 0.31,
      "receptions": 2.4,
      "targets": 3.1,
      "passingYards": 0,
      "rushingYards": 67.4,
      "receivingYards": 15.6
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 21.7,
      "totalYards": 107,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 75,
      "receivingYards": 32
    }
  },
  "sleeper-11620": {
    "season": "2024",
    "games": 17,
    "team": "CHI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 15,
      "rushingTds": 0,
      "receptions": 54,
      "targets": 101,
      "receivingYards": 734,
      "receivingTds": 3,
      "fantasyPoints": 90.9,
      "fantasyPointsPpr": 144.9,
      "totalYards": 749,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 5.3,
      "fantasyPointsPpr": 8.5,
      "totalYards": 44.1,
      "totalTds": 0.18,
      "receptions": 3.2,
      "targets": 5.9,
      "passingYards": 0,
      "rushingYards": 0.9,
      "receivingYards": 43.2
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 23.4,
      "totalYards": 114,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 2,
      "receivingYards": 112
    }
  },
  "sleeper-6804": {
    "season": "2024",
    "games": 16,
    "team": "GB",
    "position": "QB",
    "totals": {
      "completions": 288,
      "attempts": 458,
      "passingYards": 3601,
      "passingTds": 25,
      "interceptions": 14,
      "carries": 27,
      "rushingYards": 93,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 237.3,
      "fantasyPointsPpr": 237.3,
      "totalYards": 3694,
      "totalTds": 26
    },
    "perGame": {
      "fantasyPoints": 14.8,
      "fantasyPointsPpr": 14.8,
      "totalYards": 230.9,
      "totalTds": 1.63,
      "receptions": 0,
      "targets": 0,
      "passingYards": 225.1,
      "rushingYards": 5.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 28.2,
      "totalYards": 395,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 389,
      "rushingYards": 6,
      "receivingYards": 0
    }
  },
  "sleeper-421": {
    "season": "2024",
    "games": 18,
    "team": "LA",
    "position": "QB",
    "totals": {
      "completions": 385,
      "attempts": 588,
      "passingYards": 4295,
      "passingTds": 24,
      "interceptions": 8,
      "carries": 34,
      "rushingYards": 45,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 250.3,
      "fantasyPointsPpr": 250.3,
      "totalYards": 4340,
      "totalTds": 24
    },
    "perGame": {
      "fantasyPoints": 13.9,
      "fantasyPointsPpr": 13.9,
      "totalYards": 241.1,
      "totalTds": 1.33,
      "receptions": 0,
      "targets": 0,
      "passingYards": 238.6,
      "rushingYards": 2.5,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 27.8,
      "totalYards": 295,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 295,
      "rushingYards": 0,
      "receivingYards": 0
    }
  },
  "sleeper-7594": {
    "season": "2024",
    "games": 15,
    "team": "CAR",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 250,
      "rushingYards": 1195,
      "rushingTds": 10,
      "receptions": 43,
      "targets": 54,
      "receivingYards": 171,
      "receivingTds": 1,
      "fantasyPoints": 198.6,
      "fantasyPointsPpr": 241.6,
      "totalYards": 1366,
      "totalTds": 11
    },
    "perGame": {
      "fantasyPoints": 13.2,
      "fantasyPointsPpr": 16.1,
      "totalYards": 91.1,
      "totalTds": 0.73,
      "receptions": 2.9,
      "targets": 3.6,
      "passingYards": 0,
      "rushingYards": 79.7,
      "receivingYards": 11.4
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 32.5,
      "totalYards": 165,
      "totalTds": 2,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 152,
      "receivingYards": 13
    }
  },
  "sleeper-9487": {
    "season": "2024",
    "games": 13,
    "team": "JAX",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 32,
      "targets": 51,
      "receivingYards": 390,
      "receivingTds": 3,
      "fantasyPoints": 65,
      "fantasyPointsPpr": 97,
      "totalYards": 390,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 5,
      "fantasyPointsPpr": 7.5,
      "totalYards": 30,
      "totalTds": 0.23,
      "receptions": 2.5,
      "targets": 3.9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 30
    },
    "bestWeek": {
      "week": 13,
      "fantasyPointsPpr": 24.3,
      "totalYards": 103,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 103
    }
  },
  "sleeper-11586": {
    "season": "2024",
    "games": 14,
    "team": "LA",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 58,
      "rushingYards": 207,
      "rushingTds": 0,
      "receptions": 7,
      "targets": 8,
      "receivingYards": 58,
      "receivingTds": 0,
      "fantasyPoints": 26.5,
      "fantasyPointsPpr": 33.5,
      "totalYards": 265,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.9,
      "fantasyPointsPpr": 2.4,
      "totalYards": 18.9,
      "totalTds": 0,
      "receptions": 0.5,
      "targets": 0.6,
      "passingYards": 0,
      "rushingYards": 14.8,
      "receivingYards": 4.1
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 4.3,
      "totalYards": 33,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 25,
      "receivingYards": 8
    }
  },
  "sleeper-6806": {
    "season": "2024",
    "games": 14,
    "team": "LAC",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 204,
      "rushingYards": 931,
      "rushingTds": 9,
      "receptions": 32,
      "targets": 39,
      "receivingYards": 153,
      "receivingTds": 0,
      "fantasyPoints": 162.4,
      "fantasyPointsPpr": 194.4,
      "totalYards": 1084,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 11.6,
      "fantasyPointsPpr": 13.9,
      "totalYards": 77.4,
      "totalTds": 0.64,
      "receptions": 2.3,
      "targets": 2.8,
      "passingYards": 0,
      "rushingYards": 66.5,
      "receivingYards": 10.9
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 24.5,
      "totalYards": 105,
      "totalTds": 2,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 85,
      "receivingYards": 20
    }
  },
  "sleeper-5045": {
    "season": "2024",
    "games": 17,
    "team": "DEN",
    "position": "WR",
    "totals": {
      "completions": 2,
      "attempts": 2,
      "passingYards": 30,
      "passingTds": 1,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 86,
      "targets": 144,
      "receivingYards": 1156,
      "receivingTds": 8,
      "fantasyPoints": 166.8,
      "fantasyPointsPpr": 252.8,
      "totalYards": 1186,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 9.8,
      "fantasyPointsPpr": 14.9,
      "totalYards": 69.8,
      "totalTds": 0.53,
      "receptions": 5.1,
      "targets": 8.5,
      "passingYards": 1.8,
      "rushingYards": 0,
      "receivingYards": 68
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 29.7,
      "totalYards": 97,
      "totalTds": 2,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 97
    }
  },
  "sleeper-5846": {
    "season": "2024",
    "games": 15,
    "team": "SEA",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 66,
      "targets": 108,
      "receivingYards": 992,
      "receivingTds": 5,
      "fantasyPoints": 125.2,
      "fantasyPointsPpr": 191.2,
      "totalYards": 992,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 8.3,
      "fantasyPointsPpr": 12.7,
      "totalYards": 66.1,
      "totalTds": 0.33,
      "receptions": 4.4,
      "targets": 7.2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 66.1
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 28.9,
      "totalYards": 129,
      "totalTds": 1,
      "receptions": 10,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 129
    }
  },
  "sleeper-4892": {
    "season": "2024",
    "games": 18,
    "team": "TB",
    "position": "QB",
    "totals": {
      "completions": 422,
      "attempts": 588,
      "passingYards": 4685,
      "passingTds": 43,
      "interceptions": 16,
      "carries": 67,
      "rushingYards": 401,
      "rushingTds": 3,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 381.5,
      "fantasyPointsPpr": 381.5,
      "totalYards": 5086,
      "totalTds": 46
    },
    "perGame": {
      "fantasyPoints": 21.2,
      "fantasyPointsPpr": 21.2,
      "totalYards": 282.6,
      "totalTds": 2.56,
      "receptions": 0,
      "targets": 0,
      "passingYards": 260.3,
      "rushingYards": 22.3,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 34.6,
      "totalYards": 361,
      "totalTds": 5,
      "receptions": 0,
      "passingYards": 359,
      "rushingYards": 2,
      "receivingYards": 0
    }
  },
  "sleeper-10232": {
    "season": "2024",
    "games": 16,
    "team": "ARI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 7,
      "rushingTds": 0,
      "receptions": 47,
      "targets": 71,
      "receivingYards": 548,
      "receivingTds": 4,
      "fantasyPoints": 77.5,
      "fantasyPointsPpr": 124.5,
      "totalYards": 555,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 4.8,
      "fantasyPointsPpr": 7.8,
      "totalYards": 34.7,
      "totalTds": 0.25,
      "receptions": 2.9,
      "targets": 4.4,
      "passingYards": 0,
      "rushingYards": 0.4,
      "receivingYards": 34.3
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 14.4,
      "totalYards": 64,
      "totalTds": 0,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 64
    }
  },
  "sleeper-5947": {
    "season": "2024",
    "games": 15,
    "team": "LV",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 23,
      "rushingTds": 0,
      "receptions": 87,
      "targets": 129,
      "receivingYards": 1027,
      "receivingTds": 4,
      "fantasyPoints": 131,
      "fantasyPointsPpr": 218,
      "totalYards": 1050,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 8.7,
      "fantasyPointsPpr": 14.5,
      "totalYards": 70,
      "totalTds": 0.27,
      "receptions": 5.8,
      "targets": 8.6,
      "passingYards": 0,
      "rushingYards": 1.5,
      "receivingYards": 68.5
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 27.3,
      "totalYards": 123,
      "totalTds": 1,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 123
    }
  },
  "sleeper-4217": {
    "season": "2024",
    "games": 15,
    "team": "SF",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 78,
      "targets": 94,
      "receivingYards": 1106,
      "receivingTds": 8,
      "fantasyPoints": 158.6,
      "fantasyPointsPpr": 236.6,
      "totalYards": 1106,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 10.6,
      "fantasyPointsPpr": 15.8,
      "totalYards": 73.7,
      "totalTds": 0.53,
      "receptions": 5.2,
      "targets": 6.3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 73.7
    },
    "bestWeek": {
      "week": 8,
      "fantasyPointsPpr": 24.8,
      "totalYards": 128,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 128
    }
  },
  "sleeper-10236": {
    "season": "2024",
    "games": 16,
    "team": "BUF",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 50,
      "targets": 84,
      "receivingYards": 519,
      "receivingTds": 2,
      "fantasyPoints": 63.9,
      "fantasyPointsPpr": 113.9,
      "totalYards": 519,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 4,
      "fantasyPointsPpr": 7.1,
      "totalYards": 32.4,
      "totalTds": 0.13,
      "receptions": 3.1,
      "targets": 5.3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 32.4
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 13.1,
      "totalYards": 41,
      "totalTds": 1,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 41
    }
  },
  "sleeper-4199": {
    "season": "2024",
    "games": 18,
    "team": "MIN",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 268,
      "rushingYards": 1186,
      "rushingTds": 5,
      "receptions": 54,
      "targets": 68,
      "receivingYards": 420,
      "receivingTds": 2,
      "fantasyPoints": 196.6,
      "fantasyPointsPpr": 250.6,
      "totalYards": 1606,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 10.9,
      "fantasyPointsPpr": 13.9,
      "totalYards": 89.2,
      "totalTds": 0.39,
      "receptions": 3,
      "targets": 3.8,
      "passingYards": 0,
      "rushingYards": 65.9,
      "receivingYards": 23.3
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 25.8,
      "totalYards": 148,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 102,
      "receivingYards": 46
    }
  },
  "sleeper-5849": {
    "season": "2024",
    "games": 17,
    "team": "ARI",
    "position": "QB",
    "totals": {
      "completions": 372,
      "attempts": 541,
      "passingYards": 3851,
      "passingTds": 21,
      "interceptions": 11,
      "carries": 78,
      "rushingYards": 572,
      "rushingTds": 5,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 297.2,
      "fantasyPointsPpr": 297.2,
      "totalYards": 4423,
      "totalTds": 26
    },
    "perGame": {
      "fantasyPoints": 17.5,
      "fantasyPointsPpr": 17.5,
      "totalYards": 260.2,
      "totalTds": 1.53,
      "receptions": 0,
      "targets": 0,
      "passingYards": 226.5,
      "rushingYards": 33.6,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 10,
      "fantasyPointsPpr": 28.7,
      "totalYards": 287,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 266,
      "rushingYards": 21,
      "receivingYards": 0
    }
  },
  "sleeper-4037": {
    "season": "2024",
    "games": 7,
    "team": "TB",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 2,
      "rushingTds": 0,
      "receptions": 50,
      "targets": 62,
      "receivingYards": 576,
      "receivingTds": 5,
      "fantasyPoints": 87.8,
      "fantasyPointsPpr": 137.8,
      "totalYards": 578,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 12.5,
      "fantasyPointsPpr": 19.7,
      "totalYards": 82.6,
      "totalTds": 0.71,
      "receptions": 7.1,
      "targets": 8.9,
      "passingYards": 0,
      "rushingYards": 0.3,
      "receivingYards": 82.3
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 35.5,
      "totalYards": 125,
      "totalTds": 2,
      "receptions": 11,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 125
    }
  },
  "sleeper-8132": {
    "season": "2024",
    "games": 17,
    "team": "ATL",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 137,
      "rushingYards": 644,
      "rushingTds": 3,
      "receptions": 13,
      "targets": 13,
      "receivingYards": 88,
      "receivingTds": 0,
      "fantasyPoints": 93.2,
      "fantasyPointsPpr": 106.2,
      "totalYards": 732,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 5.5,
      "fantasyPointsPpr": 6.2,
      "totalYards": 43.1,
      "totalTds": 0.18,
      "receptions": 0.8,
      "targets": 0.8,
      "passingYards": 0,
      "rushingYards": 37.9,
      "receivingYards": 5.2
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 19.8,
      "totalYards": 108,
      "totalTds": 1,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 105,
      "receivingYards": 3
    }
  },
  "sleeper-1466": {
    "season": "2024",
    "games": 19,
    "team": "KC",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 1,
      "rushingTds": 0,
      "receptions": 110,
      "targets": 151,
      "receivingYards": 998,
      "receivingTds": 4,
      "fantasyPoints": 121.9,
      "fantasyPointsPpr": 231.9,
      "totalYards": 999,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 6.4,
      "fantasyPointsPpr": 12.2,
      "totalYards": 52.6,
      "totalTds": 0.21,
      "receptions": 5.8,
      "targets": 7.9,
      "passingYards": 0,
      "rushingYards": 0.1,
      "receivingYards": 52.5
    },
    "bestWeek": {
      "week": 8,
      "fantasyPointsPpr": 25,
      "totalYards": 90,
      "totalTds": 1,
      "receptions": 10,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 90
    }
  },
  "sleeper-8408": {
    "season": "2024",
    "games": 12,
    "team": "SF",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 153,
      "rushingYards": 789,
      "rushingTds": 3,
      "receptions": 11,
      "targets": 14,
      "receivingYards": 91,
      "receivingTds": 0,
      "fantasyPoints": 104,
      "fantasyPointsPpr": 115,
      "totalYards": 880,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 8.7,
      "fantasyPointsPpr": 9.6,
      "totalYards": 73.3,
      "totalTds": 0.25,
      "receptions": 0.9,
      "targets": 1.2,
      "passingYards": 0,
      "rushingYards": 65.8,
      "receivingYards": 7.6
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 24,
      "totalYards": 160,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 123,
      "receivingYards": 37
    }
  },
  "sleeper-4943": {
    "season": "2024",
    "games": 18,
    "team": "MIN",
    "position": "QB",
    "totals": {
      "completions": 386,
      "attempts": 585,
      "passingYards": 4564,
      "passingTds": 36,
      "interceptions": 13,
      "carries": 71,
      "rushingYards": 231,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 319.7,
      "fantasyPointsPpr": 319.7,
      "totalYards": 4795,
      "totalTds": 37
    },
    "perGame": {
      "fantasyPoints": 17.8,
      "fantasyPointsPpr": 17.8,
      "totalYards": 266.4,
      "totalTds": 2.06,
      "receptions": 0,
      "targets": 0,
      "passingYards": 253.6,
      "rushingYards": 12.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 34.6,
      "totalYards": 354,
      "totalTds": 5,
      "receptions": 0,
      "passingYards": 347,
      "rushingYards": 7,
      "receivingYards": 0
    }
  },
  "sleeper-3214": {
    "season": "2024",
    "games": 16,
    "team": "NE",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 66,
      "targets": 97,
      "receivingYards": 674,
      "receivingTds": 2,
      "fantasyPoints": 79.4,
      "fantasyPointsPpr": 145.4,
      "totalYards": 674,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 5,
      "fantasyPointsPpr": 9.1,
      "totalYards": 42.1,
      "totalTds": 0.13,
      "receptions": 4.1,
      "targets": 6.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 42.1
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 18.9,
      "totalYards": 109,
      "totalTds": 0,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 109
    }
  },
  "sleeper-5022": {
    "season": "2024",
    "games": 14,
    "team": "PHI",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 13,
      "rushingTds": 0,
      "receptions": 59,
      "targets": 72,
      "receivingYards": 711,
      "receivingTds": 3,
      "fantasyPoints": 90.4,
      "fantasyPointsPpr": 149.4,
      "totalYards": 724,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 6.5,
      "fantasyPointsPpr": 10.7,
      "totalYards": 51.7,
      "totalTds": 0.21,
      "receptions": 4.2,
      "targets": 5.1,
      "passingYards": 0,
      "rushingYards": 0.9,
      "receivingYards": 50.8
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 27,
      "totalYards": 170,
      "totalTds": 0,
      "receptions": 10,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 170
    }
  },
  "sleeper-5012": {
    "season": "2024",
    "games": 19,
    "team": "BAL",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 8,
      "rushingYards": 13,
      "rushingTds": 0,
      "receptions": 62,
      "targets": 79,
      "receivingYards": 761,
      "receivingTds": 11,
      "fantasyPoints": 141.4,
      "fantasyPointsPpr": 203.4,
      "totalYards": 774,
      "totalTds": 11
    },
    "perGame": {
      "fantasyPoints": 7.4,
      "fantasyPointsPpr": 10.7,
      "totalYards": 40.7,
      "totalTds": 0.58,
      "receptions": 3.3,
      "targets": 4.2,
      "passingYards": 0,
      "rushingYards": 0.7,
      "receivingYards": 40.1
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 20.1,
      "totalYards": 41,
      "totalTds": 2,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 41
    }
  },
  "sleeper-8110": {
    "season": "2024",
    "games": 14,
    "team": "DAL",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 59,
      "targets": 86,
      "receivingYards": 494,
      "receivingTds": 0,
      "fantasyPoints": 45.4,
      "fantasyPointsPpr": 104.4,
      "totalYards": 494,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 3.2,
      "fantasyPointsPpr": 7.5,
      "totalYards": 35.3,
      "totalTds": 0,
      "receptions": 4.2,
      "targets": 6.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 35.3
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 15.5,
      "totalYards": 95,
      "totalTds": 0,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 95
    }
  },
  "sleeper-5001": {
    "season": "2024",
    "games": 19,
    "team": "HOU",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 59,
      "targets": 93,
      "receivingYards": 618,
      "receivingTds": 2,
      "fantasyPoints": 73.8,
      "fantasyPointsPpr": 132.8,
      "totalYards": 618,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 3.9,
      "fantasyPointsPpr": 7,
      "totalYards": 32.5,
      "totalTds": 0.11,
      "receptions": 3.1,
      "targets": 4.9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 32.5
    },
    "bestWeek": {
      "week": 13,
      "fantasyPointsPpr": 17.1,
      "totalYards": 61,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 61
    }
  },
  "sleeper-11581": {
    "season": "2024",
    "games": 1,
    "team": "GB",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 6,
      "rushingYards": 15,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 1,
      "receivingYards": 3,
      "receivingTds": 0,
      "fantasyPoints": 1.8,
      "fantasyPointsPpr": 2.8,
      "totalYards": 18,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.8,
      "fantasyPointsPpr": 2.8,
      "totalYards": 18,
      "totalTds": 0,
      "receptions": 1,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 15,
      "receivingYards": 3
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 2.8,
      "totalYards": 18,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 15,
      "receivingYards": 3
    }
  },
  "sleeper-9756": {
    "season": "2024",
    "games": 16,
    "team": "MIN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 20,
      "rushingTds": 1,
      "receptions": 66,
      "targets": 107,
      "receivingYards": 904,
      "receivingTds": 9,
      "fantasyPoints": 152.4,
      "fantasyPointsPpr": 218.4,
      "totalYards": 924,
      "totalTds": 10
    },
    "perGame": {
      "fantasyPoints": 9.5,
      "fantasyPointsPpr": 13.7,
      "totalYards": 57.8,
      "totalTds": 0.63,
      "receptions": 4.1,
      "targets": 6.7,
      "passingYards": 0,
      "rushingYards": 1.3,
      "receivingYards": 56.5
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 39.3,
      "totalYards": 133,
      "totalTds": 3,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 133
    }
  },
  "sleeper-9753": {
    "season": "2024",
    "games": 17,
    "team": "SEA",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 135,
      "rushingYards": 569,
      "rushingTds": 8,
      "receptions": 42,
      "targets": 52,
      "receivingYards": 308,
      "receivingTds": 1,
      "fantasyPoints": 141.7,
      "fantasyPointsPpr": 183.7,
      "totalYards": 877,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 8.3,
      "fantasyPointsPpr": 10.8,
      "totalYards": 51.6,
      "totalTds": 0.53,
      "receptions": 2.5,
      "targets": 3.1,
      "passingYards": 0,
      "rushingYards": 33.5,
      "receivingYards": 18.1
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 38.3,
      "totalYards": 193,
      "totalTds": 2,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 134,
      "receivingYards": 59
    }
  },
  "sleeper-9758": {
    "season": "2024",
    "games": 19,
    "team": "HOU",
    "position": "QB",
    "totals": {
      "completions": 377,
      "attempts": 593,
      "passingYards": 4254,
      "passingTds": 21,
      "interceptions": 13,
      "carries": 64,
      "rushingYards": 317,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 1,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 251.9,
      "fantasyPointsPpr": 251.9,
      "totalYards": 4571,
      "totalTds": 21
    },
    "perGame": {
      "fantasyPoints": 13.3,
      "fantasyPointsPpr": 13.3,
      "totalYards": 240.6,
      "totalTds": 1.11,
      "receptions": 0,
      "targets": 0.1,
      "passingYards": 223.9,
      "rushingYards": 16.7,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 23.5,
      "totalYards": 362,
      "totalTds": 2,
      "receptions": 0,
      "passingYards": 345,
      "rushingYards": 17,
      "receivingYards": 0
    }
  },
  "sleeper-7002": {
    "season": "2024",
    "games": 15,
    "team": "NO",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 50,
      "targets": 66,
      "receivingYards": 548,
      "receivingTds": 3,
      "fantasyPoints": 72.8,
      "fantasyPointsPpr": 122.8,
      "totalYards": 548,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 4.9,
      "fantasyPointsPpr": 8.2,
      "totalYards": 36.5,
      "totalTds": 0.2,
      "receptions": 3.3,
      "targets": 4.4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 36.5
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 15,
      "totalYards": 50,
      "totalTds": 1,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 50
    }
  },
  "sleeper-9480": {
    "season": "2024",
    "games": 14,
    "team": "JAX",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 40,
      "targets": 53,
      "receivingYards": 411,
      "receivingTds": 2,
      "fantasyPoints": 51.1,
      "fantasyPointsPpr": 91.1,
      "totalYards": 411,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 3.6,
      "fantasyPointsPpr": 6.5,
      "totalYards": 29.4,
      "totalTds": 0.14,
      "receptions": 2.9,
      "targets": 3.8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 29.4
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 18.3,
      "totalYards": 73,
      "totalTds": 0,
      "receptions": 11,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 73
    }
  },
  "sleeper-9754": {
    "season": "2024",
    "games": 16,
    "team": "LAC",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 6,
      "rushingTds": 0,
      "receptions": 55,
      "targets": 96,
      "receivingYards": 711,
      "receivingTds": 8,
      "fantasyPoints": 119.7,
      "fantasyPointsPpr": 174.7,
      "totalYards": 717,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 7.5,
      "fantasyPointsPpr": 10.9,
      "totalYards": 44.8,
      "totalTds": 0.5,
      "receptions": 3.4,
      "targets": 6,
      "passingYards": 0,
      "rushingYards": 0.4,
      "receivingYards": 44.4
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 31.6,
      "totalYards": 186,
      "totalTds": 0,
      "receptions": 13,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 186
    }
  },
  "sleeper-2449": {
    "season": "2024",
    "games": 8,
    "team": "HOU",
    "position": "WR",
    "totals": {
      "completions": 1,
      "attempts": 1,
      "passingYards": 13,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 8,
      "rushingTds": 1,
      "receptions": 47,
      "targets": 64,
      "receivingYards": 496,
      "receivingTds": 3,
      "fantasyPoints": 74.9,
      "fantasyPointsPpr": 121.9,
      "totalYards": 517,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 9.4,
      "fantasyPointsPpr": 15.2,
      "totalYards": 64.6,
      "totalTds": 0.5,
      "receptions": 5.9,
      "targets": 8,
      "passingYards": 1.6,
      "rushingYards": 1,
      "receivingYards": 62
    },
    "bestWeek": {
      "week": 1,
      "fantasyPointsPpr": 21.9,
      "totalYards": 39,
      "totalTds": 2,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 6,
      "receivingYards": 33
    }
  },
  "sleeper-8126": {
    "season": "2024",
    "games": 17,
    "team": "NYG",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 18,
      "rushingTds": 0,
      "receptions": 93,
      "targets": 140,
      "receivingYards": 699,
      "receivingTds": 3,
      "fantasyPoints": 89.7,
      "fantasyPointsPpr": 182.7,
      "totalYards": 717,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 5.3,
      "fantasyPointsPpr": 10.7,
      "totalYards": 42.2,
      "totalTds": 0.18,
      "receptions": 5.5,
      "targets": 8.2,
      "passingYards": 0,
      "rushingYards": 1.1,
      "receivingYards": 41.1
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 18.1,
      "totalYards": 71,
      "totalTds": 0,
      "receptions": 11,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 71
    }
  },
  "sleeper-8131": {
    "season": "2024",
    "games": 17,
    "team": "BAL",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 49,
      "targets": 67,
      "receivingYards": 603,
      "receivingTds": 7,
      "fantasyPoints": 100.3,
      "fantasyPointsPpr": 149.3,
      "totalYards": 603,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 5.9,
      "fantasyPointsPpr": 8.8,
      "totalYards": 35.5,
      "totalTds": 0.41,
      "receptions": 2.9,
      "targets": 3.9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 35.5
    },
    "bestWeek": {
      "week": 1,
      "fantasyPointsPpr": 26.1,
      "totalYards": 111,
      "totalTds": 1,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 111
    }
  },
  "sleeper-9500": {
    "season": "2024",
    "games": 14,
    "team": "IND",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": -1,
      "rushingTds": 0,
      "receptions": 72,
      "targets": 107,
      "receivingYards": 803,
      "receivingTds": 5,
      "fantasyPoints": 110.2,
      "fantasyPointsPpr": 182.2,
      "totalYards": 802,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 7.9,
      "fantasyPointsPpr": 13,
      "totalYards": 57.3,
      "totalTds": 0.36,
      "receptions": 5.1,
      "targets": 7.6,
      "passingYards": 0,
      "rushingYards": -0.1,
      "receivingYards": 57.4
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 22.2,
      "totalYards": 82,
      "totalTds": 1,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 82
    }
  },
  "sleeper-4035": {
    "season": "2024",
    "games": 14,
    "team": "NO",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 228,
      "rushingYards": 950,
      "rushingTds": 6,
      "receptions": 68,
      "targets": 89,
      "receivingYards": 543,
      "receivingTds": 2,
      "fantasyPoints": 197.3,
      "fantasyPointsPpr": 265.3,
      "totalYards": 1493,
      "totalTds": 8
    },
    "perGame": {
      "fantasyPoints": 14.1,
      "fantasyPointsPpr": 18.9,
      "totalYards": 106.6,
      "totalTds": 0.57,
      "receptions": 4.9,
      "targets": 6.4,
      "passingYards": 0,
      "rushingYards": 67.9,
      "receivingYards": 38.8
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 44,
      "totalYards": 180,
      "totalTds": 4,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 115,
      "receivingYards": 65
    }
  },
  "sleeper-8134": {
    "season": "2024",
    "games": 18,
    "team": "BUF",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 4,
      "rushingTds": 0,
      "receptions": 94,
      "targets": 120,
      "receivingYards": 995,
      "receivingTds": 4,
      "fantasyPoints": 123.9,
      "fantasyPointsPpr": 217.9,
      "totalYards": 999,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 6.9,
      "fantasyPointsPpr": 12.1,
      "totalYards": 55.5,
      "totalTds": 0.22,
      "receptions": 5.2,
      "targets": 6.7,
      "passingYards": 0,
      "rushingYards": 0.2,
      "receivingYards": 55.3
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 21.6,
      "totalYards": 106,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 106
    }
  },
  "sleeper-8161": {
    "season": "2024",
    "games": 6,
    "team": "GB",
    "position": "QB",
    "totals": {
      "completions": 40,
      "attempts": 54,
      "passingYards": 550,
      "passingTds": 3,
      "interceptions": 0,
      "carries": 20,
      "rushingYards": 138,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 51.8,
      "fantasyPointsPpr": 51.8,
      "totalYards": 688,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 8.6,
      "fantasyPointsPpr": 8.6,
      "totalYards": 114.7,
      "totalTds": 0.67,
      "receptions": 0,
      "targets": 0,
      "passingYards": 91.7,
      "rushingYards": 23,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 25.4,
      "totalYards": 275,
      "totalTds": 2,
      "receptions": 0,
      "passingYards": 202,
      "rushingYards": 73,
      "receivingYards": 0
    }
  },
  "sleeper-11624": {
    "season": "2024",
    "games": 19,
    "team": "KC",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 23,
      "rushingYards": 112,
      "rushingTds": 3,
      "receptions": 78,
      "targets": 119,
      "receivingYards": 925,
      "receivingTds": 9,
      "fantasyPoints": 175.7,
      "fantasyPointsPpr": 253.7,
      "totalYards": 1037,
      "totalTds": 12
    },
    "perGame": {
      "fantasyPoints": 9.2,
      "fantasyPointsPpr": 13.4,
      "totalYards": 54.6,
      "totalTds": 0.63,
      "receptions": 4.1,
      "targets": 6.3,
      "passingYards": 0,
      "rushingYards": 5.9,
      "receivingYards": 48.7
    },
    "bestWeek": {
      "week": 22,
      "fantasyPointsPpr": 35.7,
      "totalYards": 157,
      "totalTds": 2,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 157
    }
  },
  "sleeper-9508": {
    "season": "2024",
    "games": 12,
    "team": "TEN",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 84,
      "rushingYards": 312,
      "rushingTds": 4,
      "receptions": 30,
      "targets": 35,
      "receivingYards": 224,
      "receivingTds": 1,
      "fantasyPoints": 83.6,
      "fantasyPointsPpr": 113.6,
      "totalYards": 536,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 7,
      "fantasyPointsPpr": 9.5,
      "totalYards": 44.7,
      "totalTds": 0.42,
      "receptions": 2.5,
      "targets": 2.9,
      "passingYards": 0,
      "rushingYards": 26,
      "receivingYards": 18.7
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 27.2,
      "totalYards": 92,
      "totalTds": 2,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 5,
      "receivingYards": 87
    }
  },
  "sleeper-7049": {
    "season": "2024",
    "games": 15,
    "team": "SF",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 77,
      "targets": 113,
      "receivingYards": 975,
      "receivingTds": 6,
      "fantasyPoints": 133.5,
      "fantasyPointsPpr": 210.5,
      "totalYards": 975,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 8.9,
      "fantasyPointsPpr": 14,
      "totalYards": 65,
      "totalTds": 0.4,
      "receptions": 5.1,
      "targets": 7.5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 65
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 46.5,
      "totalYards": 175,
      "totalTds": 3,
      "receptions": 11,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 175
    }
  },
  "sleeper-8136": {
    "season": "2024",
    "games": 16,
    "team": "TB",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 145,
      "rushingYards": 614,
      "rushingTds": 3,
      "receptions": 53,
      "targets": 59,
      "receivingYards": 407,
      "receivingTds": 6,
      "fantasyPoints": 150.1,
      "fantasyPointsPpr": 203.1,
      "totalYards": 1021,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 9.4,
      "fantasyPointsPpr": 12.7,
      "totalYards": 63.8,
      "totalTds": 0.56,
      "receptions": 3.3,
      "targets": 3.7,
      "passingYards": 0,
      "rushingYards": 38.4,
      "receivingYards": 25.4
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 29.1,
      "totalYards": 111,
      "totalTds": 2,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 40,
      "receivingYards": 71
    }
  },
  "sleeper-11603": {
    "season": "2024",
    "games": 14,
    "team": "SEA",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 30,
      "targets": 38,
      "receivingYards": 245,
      "receivingTds": 4,
      "fantasyPoints": 48.5,
      "fantasyPointsPpr": 78.5,
      "totalYards": 245,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 3.5,
      "fantasyPointsPpr": 5.6,
      "totalYards": 17.5,
      "totalTds": 0.29,
      "receptions": 2.1,
      "targets": 2.7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 17.5
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 14.4,
      "totalYards": 34,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 34
    }
  },
  "sleeper-5844": {
    "season": "2024",
    "games": 11,
    "team": "MIN",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 46,
      "targets": 67,
      "receivingYards": 519,
      "receivingTds": 1,
      "fantasyPoints": 57.9,
      "fantasyPointsPpr": 103.9,
      "totalYards": 519,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 5.3,
      "fantasyPointsPpr": 9.4,
      "totalYards": 47.2,
      "totalTds": 0.09,
      "receptions": 4.2,
      "targets": 6.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 47.2
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 18.4,
      "totalYards": 114,
      "totalTds": 0,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 114
    }
  },
  "sleeper-5872": {
    "season": "2024",
    "games": 14,
    "team": "SF",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 42,
      "rushingYards": 136,
      "rushingTds": 1,
      "receptions": 51,
      "targets": 81,
      "receivingYards": 670,
      "receivingTds": 3,
      "fantasyPoints": 104.6,
      "fantasyPointsPpr": 155.6,
      "totalYards": 806,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 7.5,
      "fantasyPointsPpr": 11.1,
      "totalYards": 57.6,
      "totalTds": 0.29,
      "receptions": 3.6,
      "targets": 5.8,
      "passingYards": 0,
      "rushingYards": 9.7,
      "receivingYards": 47.9
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 25.1,
      "totalYards": 121,
      "totalTds": 1,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 25,
      "receivingYards": 96
    }
  },
  "sleeper-5870": {
    "season": "2024",
    "games": 10,
    "team": "NYG",
    "position": "QB",
    "totals": {
      "completions": 216,
      "attempts": 341,
      "passingYards": 2070,
      "passingTds": 8,
      "interceptions": 7,
      "carries": 67,
      "rushingYards": 265,
      "rushingTds": 2,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 135.3,
      "fantasyPointsPpr": 135.3,
      "totalYards": 2335,
      "totalTds": 10
    },
    "perGame": {
      "fantasyPoints": 13.5,
      "fantasyPointsPpr": 13.5,
      "totalYards": 233.5,
      "totalTds": 1,
      "receptions": 0,
      "targets": 0,
      "passingYards": 207,
      "rushingYards": 26.5,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 24.4,
      "totalYards": 228,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 174,
      "rushingYards": 54,
      "receivingYards": 0
    }
  },
  "sleeper-11646": {
    "season": "2024",
    "games": 11,
    "team": "CAR",
    "position": "WR",
    "totals": {
      "completions": 1,
      "attempts": 1,
      "passingYards": 19,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 32,
      "targets": 46,
      "receivingYards": 478,
      "receivingTds": 2,
      "fantasyPoints": 60.6,
      "fantasyPointsPpr": 92.6,
      "totalYards": 497,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 5.5,
      "fantasyPointsPpr": 8.4,
      "totalYards": 45.2,
      "totalTds": 0.18,
      "receptions": 2.9,
      "targets": 4.2,
      "passingYards": 1.7,
      "rushingYards": 0,
      "receivingYards": 43.5
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 21,
      "totalYards": 110,
      "totalTds": 1,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 110
    }
  },
  "sleeper-9228": {
    "season": "2024",
    "games": 14,
    "team": "CAR",
    "position": "QB",
    "totals": {
      "completions": 234,
      "attempts": 384,
      "passingYards": 2403,
      "passingTds": 15,
      "interceptions": 9,
      "carries": 43,
      "rushingYards": 249,
      "rushingTds": 6,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 195,
      "fantasyPointsPpr": 195,
      "totalYards": 2652,
      "totalTds": 21
    },
    "perGame": {
      "fantasyPoints": 13.9,
      "fantasyPointsPpr": 13.9,
      "totalYards": 189.4,
      "totalTds": 1.5,
      "receptions": 0,
      "targets": 0,
      "passingYards": 171.6,
      "rushingYards": 17.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 36.4,
      "totalYards": 275,
      "totalTds": 5,
      "receptions": 0,
      "passingYards": 251,
      "rushingYards": 24,
      "receivingYards": 0
    }
  },
  "sleeper-11576": {
    "season": "2024",
    "games": 17,
    "team": "NYJ",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 92,
      "rushingYards": 334,
      "rushingTds": 2,
      "receptions": 19,
      "targets": 27,
      "receivingYards": 148,
      "receivingTds": 1,
      "fantasyPoints": 66.2,
      "fantasyPointsPpr": 85.2,
      "totalYards": 482,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 3.9,
      "fantasyPointsPpr": 5,
      "totalYards": 28.4,
      "totalTds": 0.18,
      "receptions": 1.1,
      "targets": 1.6,
      "passingYards": 0,
      "rushingYards": 19.6,
      "receivingYards": 8.7
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 19.6,
      "totalYards": 56,
      "totalTds": 2,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 33,
      "receivingYards": 23
    }
  },
  "sleeper-6865": {
    "season": "2024",
    "games": 17,
    "team": "LA",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 34,
      "targets": 53,
      "receivingYards": 316,
      "receivingTds": 2,
      "fantasyPoints": 43.6,
      "fantasyPointsPpr": 77.6,
      "totalYards": 316,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 2.6,
      "fantasyPointsPpr": 4.6,
      "totalYards": 18.6,
      "totalTds": 0.12,
      "receptions": 2,
      "targets": 3.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 18.6
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 12.2,
      "totalYards": 52,
      "totalTds": 0,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 52
    }
  },
  "sleeper-11647": {
    "season": "2024",
    "games": 9,
    "team": "LAC",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 43,
      "rushingYards": 155,
      "rushingTds": 0,
      "receptions": 5,
      "targets": 9,
      "receivingYards": 62,
      "receivingTds": 1,
      "fantasyPoints": 27.7,
      "fantasyPointsPpr": 32.7,
      "totalYards": 217,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 3.1,
      "fantasyPointsPpr": 3.6,
      "totalYards": 24.1,
      "totalTds": 0.11,
      "receptions": 0.6,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 17.2,
      "receivingYards": 6.9
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 13.1,
      "totalYards": 51,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 11,
      "receivingYards": 40
    }
  },
  "sleeper-11597": {
    "season": "2024",
    "games": 10,
    "team": "NYG",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 29,
      "targets": 43,
      "receivingYards": 331,
      "receivingTds": 1,
      "fantasyPoints": 39.1,
      "fantasyPointsPpr": 68.1,
      "totalYards": 331,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 3.9,
      "fantasyPointsPpr": 6.8,
      "totalYards": 33.1,
      "totalTds": 0.1,
      "receptions": 2.9,
      "targets": 4.3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 33.1
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 14.1,
      "totalYards": 51,
      "totalTds": 1,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 51
    }
  },
  "sleeper-8111": {
    "season": "2024",
    "games": 15,
    "team": "TB",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": -4,
      "rushingTds": 0,
      "receptions": 61,
      "targets": 89,
      "receivingYards": 632,
      "receivingTds": 4,
      "fantasyPoints": 84.8,
      "fantasyPointsPpr": 145.8,
      "totalYards": 628,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 5.7,
      "fantasyPointsPpr": 9.7,
      "totalYards": 41.9,
      "totalTds": 0.27,
      "receptions": 4.1,
      "targets": 5.9,
      "passingYards": 0,
      "rushingYards": -0.3,
      "receivingYards": 42.1
    },
    "bestWeek": {
      "week": 8,
      "fantasyPointsPpr": 29.1,
      "totalYards": 81,
      "totalTds": 2,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 81
    }
  },
  "sleeper-9511": {
    "season": "2024",
    "games": 2,
    "team": "BAL",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 15,
      "rushingYards": 30,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 1,
      "receivingYards": 28,
      "receivingTds": 0,
      "fantasyPoints": 5.8,
      "fantasyPointsPpr": 6.8,
      "totalYards": 58,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 2.9,
      "fantasyPointsPpr": 3.4,
      "totalYards": 29,
      "totalTds": 0,
      "receptions": 0.5,
      "targets": 0.5,
      "passingYards": 0,
      "rushingYards": 15,
      "receivingYards": 14
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 5.8,
      "totalYards": 48,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 20,
      "receivingYards": 28
    }
  },
  "sleeper-8676": {
    "season": "2024",
    "games": 6,
    "team": "NO",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 6,
      "rushingYards": 29,
      "rushingTds": 0,
      "receptions": 20,
      "targets": 41,
      "receivingYards": 349,
      "receivingTds": 3,
      "fantasyPoints": 61.8,
      "fantasyPointsPpr": 81.8,
      "totalYards": 378,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 10.3,
      "fantasyPointsPpr": 13.6,
      "totalYards": 63,
      "totalTds": 0.5,
      "receptions": 3.3,
      "targets": 6.8,
      "passingYards": 0,
      "rushingYards": 4.8,
      "receivingYards": 58.2
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 20.9,
      "totalYards": 109,
      "totalTds": 1,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 13,
      "receivingYards": 96
    }
  },
  "sleeper-9506": {
    "season": "2024",
    "games": 11,
    "team": "TB",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 50,
      "rushingYards": 308,
      "rushingTds": 2,
      "receptions": 9,
      "targets": 12,
      "receivingYards": 109,
      "receivingTds": 1,
      "fantasyPoints": 59.7,
      "fantasyPointsPpr": 68.7,
      "totalYards": 417,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 5.4,
      "fantasyPointsPpr": 6.2,
      "totalYards": 37.9,
      "totalTds": 0.27,
      "receptions": 0.8,
      "targets": 1.1,
      "passingYards": 0,
      "rushingYards": 28,
      "receivingYards": 9.9
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 34.2,
      "totalYards": 192,
      "totalTds": 2,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 136,
      "receivingYards": 56
    }
  },
  "sleeper-6783": {
    "season": "2024",
    "games": 17,
    "team": "CLE",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 90,
      "targets": 145,
      "receivingYards": 1229,
      "receivingTds": 4,
      "fantasyPoints": 150.9,
      "fantasyPointsPpr": 240.9,
      "totalYards": 1229,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 8.9,
      "fantasyPointsPpr": 14.2,
      "totalYards": 72.3,
      "totalTds": 0.24,
      "receptions": 5.3,
      "targets": 8.5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 72.3
    },
    "bestWeek": {
      "week": 13,
      "fantasyPointsPpr": 40.5,
      "totalYards": 235,
      "totalTds": 1,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 235
    }
  },
  "sleeper-11435": {
    "season": "2024",
    "games": 18,
    "team": "GB",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 106,
      "rushingYards": 508,
      "rushingTds": 4,
      "receptions": 12,
      "targets": 17,
      "receivingYards": 71,
      "receivingTds": 1,
      "fantasyPoints": 87.9,
      "fantasyPointsPpr": 99.9,
      "totalYards": 579,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 4.9,
      "fantasyPointsPpr": 5.6,
      "totalYards": 32.2,
      "totalTds": 0.28,
      "receptions": 0.7,
      "targets": 0.9,
      "passingYards": 0,
      "rushingYards": 28.2,
      "receivingYards": 3.9
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 16.5,
      "totalYards": 85,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 50,
      "receivingYards": 35
    }
  },
  "sleeper-11625": {
    "season": "2024",
    "games": 17,
    "team": "IND",
    "position": "WR",
    "totals": {
      "completions": 1,
      "attempts": 1,
      "passingYards": 24,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 4,
      "rushingYards": 6,
      "rushingTds": 0,
      "receptions": 23,
      "targets": 55,
      "receivingYards": 312,
      "receivingTds": 0,
      "fantasyPoints": 30.8,
      "fantasyPointsPpr": 53.8,
      "totalYards": 342,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.8,
      "fantasyPointsPpr": 3.2,
      "totalYards": 20.1,
      "totalTds": 0,
      "receptions": 1.4,
      "targets": 3.2,
      "passingYards": 1.4,
      "rushingYards": 0.4,
      "receivingYards": 18.4
    },
    "bestWeek": {
      "week": 10,
      "fantasyPointsPpr": 13.1,
      "totalYards": 71,
      "totalTds": 0,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 71
    }
  },
  "sleeper-9504": {
    "season": "2024",
    "games": 15,
    "team": "NE",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 43,
      "targets": 68,
      "receivingYards": 589,
      "receivingTds": 3,
      "fantasyPoints": 78.9,
      "fantasyPointsPpr": 121.9,
      "totalYards": 589,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 5.3,
      "fantasyPointsPpr": 8.1,
      "totalYards": 39.3,
      "totalTds": 0.2,
      "receptions": 2.9,
      "targets": 4.5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 39.3
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 24.7,
      "totalYards": 117,
      "totalTds": 1,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 117
    }
  },
  "sleeper-11575": {
    "season": "2024",
    "games": 19,
    "team": "BUF",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 120,
      "rushingYards": 478,
      "rushingTds": 4,
      "receptions": 17,
      "targets": 19,
      "receivingYards": 189,
      "receivingTds": 3,
      "fantasyPoints": 108.7,
      "fantasyPointsPpr": 125.7,
      "totalYards": 667,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 5.7,
      "fantasyPointsPpr": 6.6,
      "totalYards": 35.1,
      "totalTds": 0.37,
      "receptions": 0.9,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 25.2,
      "receivingYards": 9.9
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 18.2,
      "totalYards": 152,
      "totalTds": 0,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 97,
      "receivingYards": 55
    }
  },
  "sleeper-8180": {
    "season": "2024",
    "games": 16,
    "team": "MIN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": -4,
      "rushingTds": 0,
      "receptions": 31,
      "targets": 47,
      "receivingYards": 447,
      "receivingTds": 6,
      "fantasyPoints": 80.3,
      "fantasyPointsPpr": 111.3,
      "totalYards": 443,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 5,
      "fantasyPointsPpr": 7,
      "totalYards": 27.7,
      "totalTds": 0.38,
      "receptions": 1.9,
      "targets": 2.9,
      "passingYards": 0,
      "rushingYards": -0.3,
      "receivingYards": 27.9
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 19.1,
      "totalYards": 81,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 81
    }
  },
  "sleeper-11627": {
    "season": "2024",
    "games": 17,
    "team": "DEN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 8,
      "rushingTds": 0,
      "receptions": 30,
      "targets": 56,
      "receivingYards": 317,
      "receivingTds": 3,
      "fantasyPoints": 50.5,
      "fantasyPointsPpr": 80.5,
      "totalYards": 325,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 3,
      "fantasyPointsPpr": 4.7,
      "totalYards": 19.1,
      "totalTds": 0.18,
      "receptions": 1.8,
      "targets": 3.3,
      "passingYards": 0,
      "rushingYards": 0.5,
      "receivingYards": 18.6
    },
    "bestWeek": {
      "week": 19,
      "fantasyPointsPpr": 13.4,
      "totalYards": 54,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 54
    }
  },
  "sleeper-11643": {
    "season": "2024",
    "games": 13,
    "team": "MIA",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 68,
      "rushingYards": 249,
      "rushingTds": 0,
      "receptions": 3,
      "targets": 6,
      "receivingYards": 8,
      "receivingTds": 0,
      "fantasyPoints": 23.7,
      "fantasyPointsPpr": 26.7,
      "totalYards": 257,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.8,
      "fantasyPointsPpr": 2.1,
      "totalYards": 19.8,
      "totalTds": 0,
      "receptions": 0.2,
      "targets": 0.5,
      "passingYards": 0,
      "rushingYards": 19.2,
      "receivingYards": 0.6
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 8.6,
      "totalYards": 86,
      "totalTds": 0,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 86,
      "receivingYards": 0
    }
  },
  "sleeper-11610": {
    "season": "2024",
    "games": 12,
    "team": "MIA",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 5,
      "rushingYards": 25,
      "rushingTds": 1,
      "receptions": 26,
      "targets": 36,
      "receivingYards": 223,
      "receivingTds": 0,
      "fantasyPoints": 30.8,
      "fantasyPointsPpr": 56.8,
      "totalYards": 248,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 2.6,
      "fantasyPointsPpr": 4.7,
      "totalYards": 20.7,
      "totalTds": 0.08,
      "receptions": 2.2,
      "targets": 3,
      "passingYards": 0,
      "rushingYards": 2.1,
      "receivingYards": 18.6
    },
    "bestWeek": {
      "week": 10,
      "fantasyPointsPpr": 10.5,
      "totalYards": 35,
      "totalTds": 1,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 18,
      "receivingYards": 17
    }
  },
  "sleeper-6803": {
    "season": "2024",
    "games": 7,
    "team": "SF",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 25,
      "targets": 47,
      "receivingYards": 374,
      "receivingTds": 0,
      "fantasyPoints": 37.4,
      "fantasyPointsPpr": 62.4,
      "totalYards": 374,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 5.3,
      "fantasyPointsPpr": 8.9,
      "totalYards": 53.4,
      "totalTds": 0,
      "receptions": 3.6,
      "targets": 6.7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 53.4
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 22.7,
      "totalYards": 147,
      "totalTds": 0,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 147
    }
  },
  "sleeper-9757": {
    "season": "2024",
    "games": 6,
    "team": "NO",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 39,
      "rushingYards": 148,
      "rushingTds": 1,
      "receptions": 5,
      "targets": 8,
      "receivingYards": 33,
      "receivingTds": 0,
      "fantasyPoints": 24.1,
      "fantasyPointsPpr": 29.1,
      "totalYards": 181,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 4,
      "fantasyPointsPpr": 4.9,
      "totalYards": 30.2,
      "totalTds": 0.17,
      "receptions": 0.8,
      "targets": 1.3,
      "passingYards": 0,
      "rushingYards": 24.7,
      "receivingYards": 5.5
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 9.2,
      "totalYards": 32,
      "totalTds": 1,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 32,
      "receivingYards": 0
    }
  },
  "sleeper-1479": {
    "season": "2024",
    "games": 15,
    "team": "CHI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 1,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 1,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 70,
      "targets": 121,
      "receivingYards": 744,
      "receivingTds": 7,
      "fantasyPoints": 114.4,
      "fantasyPointsPpr": 184.4,
      "totalYards": 744,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 7.6,
      "fantasyPointsPpr": 12.3,
      "totalYards": 49.6,
      "totalTds": 0.47,
      "receptions": 4.7,
      "targets": 8.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 49.6
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 29.1,
      "totalYards": 141,
      "totalTds": 1,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 141
    }
  },
  "sleeper-4981": {
    "season": "2024",
    "games": 17,
    "team": "TEN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 8,
      "rushingYards": 55,
      "rushingTds": 1,
      "receptions": 64,
      "targets": 120,
      "receivingYards": 1017,
      "receivingTds": 4,
      "fantasyPoints": 135.2,
      "fantasyPointsPpr": 199.2,
      "totalYards": 1072,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 8,
      "fantasyPointsPpr": 11.7,
      "totalYards": 63.1,
      "totalTds": 0.29,
      "receptions": 3.8,
      "targets": 7.1,
      "passingYards": 0,
      "rushingYards": 3.2,
      "receivingYards": 59.8
    },
    "bestWeek": {
      "week": 10,
      "fantasyPointsPpr": 25.4,
      "totalYards": 84,
      "totalTds": 2,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 84
    }
  },
  "sleeper-10213": {
    "season": "2024",
    "games": 17,
    "team": "LV",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 9,
      "rushingYards": 44,
      "rushingTds": 1,
      "receptions": 47,
      "targets": 81,
      "receivingYards": 539,
      "receivingTds": 3,
      "fantasyPoints": 82.3,
      "fantasyPointsPpr": 129.3,
      "totalYards": 583,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 4.8,
      "fantasyPointsPpr": 7.6,
      "totalYards": 34.3,
      "totalTds": 0.24,
      "receptions": 2.8,
      "targets": 4.8,
      "passingYards": 0,
      "rushingYards": 2.6,
      "receivingYards": 31.7
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 22.6,
      "totalYards": 96,
      "totalTds": 1,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 96
    }
  },
  "sleeper-96": {
    "season": "2024",
    "games": 17,
    "team": "NYJ",
    "position": "QB",
    "totals": {
      "completions": 368,
      "attempts": 584,
      "passingYards": 3897,
      "passingTds": 28,
      "interceptions": 11,
      "carries": 22,
      "rushingYards": 107,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 256.6,
      "fantasyPointsPpr": 256.6,
      "totalYards": 4004,
      "totalTds": 28
    },
    "perGame": {
      "fantasyPoints": 15.1,
      "fantasyPointsPpr": 15.1,
      "totalYards": 235.5,
      "totalTds": 1.65,
      "receptions": 0,
      "targets": 0,
      "passingYards": 229.2,
      "rushingYards": 6.3,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 30.1,
      "totalYards": 334,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 289,
      "rushingYards": 45,
      "receivingYards": 0
    }
  },
  "sleeper-9502": {
    "season": "2024",
    "games": 14,
    "team": "HOU",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 9,
      "rushingYards": 43,
      "rushingTds": 0,
      "receptions": 51,
      "targets": 81,
      "receivingYards": 667,
      "receivingTds": 3,
      "fantasyPoints": 89,
      "fantasyPointsPpr": 140,
      "totalYards": 710,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 6.4,
      "fantasyPointsPpr": 10,
      "totalYards": 50.7,
      "totalTds": 0.21,
      "receptions": 3.6,
      "targets": 5.8,
      "passingYards": 0,
      "rushingYards": 3.1,
      "receivingYards": 47.6
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 21.8,
      "totalYards": 98,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 98
    }
  },
  "sleeper-11579": {
    "season": "2024",
    "games": 13,
    "team": "DEN",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 76,
      "rushingYards": 310,
      "rushingTds": 2,
      "receptions": 5,
      "targets": 5,
      "receivingYards": 27,
      "receivingTds": 0,
      "fantasyPoints": 43.7,
      "fantasyPointsPpr": 48.7,
      "totalYards": 337,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 3.4,
      "fantasyPointsPpr": 3.7,
      "totalYards": 25.9,
      "totalTds": 0.15,
      "receptions": 0.4,
      "targets": 0.4,
      "passingYards": 0,
      "rushingYards": 23.8,
      "receivingYards": 2.1
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 10.8,
      "totalYards": 48,
      "totalTds": 1,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 48,
      "receivingYards": 0
    }
  },
  "sleeper-7090": {
    "season": "2024",
    "games": 16,
    "team": "ATL",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 1,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 64,
      "targets": 106,
      "receivingYards": 992,
      "receivingTds": 5,
      "fantasyPoints": 129.2,
      "fantasyPointsPpr": 193.2,
      "totalYards": 992,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 8.1,
      "fantasyPointsPpr": 12.1,
      "totalYards": 62,
      "totalTds": 0.31,
      "receptions": 4,
      "targets": 6.6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 62
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 31.5,
      "totalYards": 105,
      "totalTds": 2,
      "receptions": 9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 105
    }
  },
  "sleeper-4039": {
    "season": "2024",
    "games": 14,
    "team": "LA",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 10,
      "rushingTds": 0,
      "receptions": 73,
      "targets": 108,
      "receivingYards": 800,
      "receivingTds": 6,
      "fantasyPoints": 117,
      "fantasyPointsPpr": 190,
      "totalYards": 810,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 8.4,
      "fantasyPointsPpr": 13.6,
      "totalYards": 57.9,
      "totalTds": 0.43,
      "receptions": 5.2,
      "targets": 7.7,
      "passingYards": 0,
      "rushingYards": 0.7,
      "receivingYards": 57.1
    },
    "bestWeek": {
      "week": 1,
      "fantasyPointsPpr": 32,
      "totalYards": 120,
      "totalTds": 1,
      "receptions": 14,
      "passingYards": 0,
      "rushingYards": 10,
      "receivingYards": 110
    }
  },
  "sleeper-11783": {
    "season": "2024",
    "games": 7,
    "team": "DAL",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 10,
      "targets": 14,
      "receivingYards": 102,
      "receivingTds": 0,
      "fantasyPoints": 8.2,
      "fantasyPointsPpr": 18.2,
      "totalYards": 102,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.2,
      "fantasyPointsPpr": 2.6,
      "totalYards": 14.6,
      "totalTds": 0,
      "receptions": 1.4,
      "targets": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 14.6
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 7.1,
      "totalYards": 41,
      "totalTds": 0,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 41
    }
  },
  "sleeper-3257": {
    "season": "2024",
    "games": 7,
    "team": "NE",
    "position": "QB",
    "totals": {
      "completions": 95,
      "attempts": 161,
      "passingYards": 826,
      "passingTds": 2,
      "interceptions": 1,
      "carries": 15,
      "rushingYards": 62,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 45.2,
      "fantasyPointsPpr": 45.2,
      "totalYards": 888,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 6.5,
      "fantasyPointsPpr": 6.5,
      "totalYards": 126.9,
      "totalTds": 0.29,
      "receptions": 0,
      "targets": 0,
      "passingYards": 118,
      "rushingYards": 8.9,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 10.6,
      "totalYards": 155,
      "totalTds": 1,
      "receptions": 0,
      "passingYards": 149,
      "rushingYards": 6,
      "receivingYards": 0
    }
  },
  "sleeper-7571": {
    "season": "2024",
    "games": 18,
    "team": "BAL",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 51,
      "targets": 79,
      "receivingYards": 846,
      "receivingTds": 11,
      "fantasyPoints": 150.6,
      "fantasyPointsPpr": 201.6,
      "totalYards": 846,
      "totalTds": 11
    },
    "perGame": {
      "fantasyPoints": 8.4,
      "fantasyPointsPpr": 11.2,
      "totalYards": 47,
      "totalTds": 0.61,
      "receptions": 2.8,
      "targets": 4.4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 47
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 23,
      "totalYards": 80,
      "totalTds": 2,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 80
    }
  },
  "sleeper-9486": {
    "season": "2024",
    "games": 18,
    "team": "GB",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 41,
      "targets": 82,
      "receivingYards": 454,
      "receivingTds": 5,
      "fantasyPoints": 75.4,
      "fantasyPointsPpr": 116.4,
      "totalYards": 454,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 4.2,
      "fantasyPointsPpr": 6.5,
      "totalYards": 25.2,
      "totalTds": 0.28,
      "receptions": 2.3,
      "targets": 4.6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 25.2
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 24.8,
      "totalYards": 78,
      "totalTds": 2,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 78
    }
  },
  "sleeper-11637": {
    "season": "2024",
    "games": 16,
    "team": "BUF",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 9,
      "rushingTds": 0,
      "receptions": 32,
      "targets": 65,
      "receivingYards": 578,
      "receivingTds": 4,
      "fantasyPoints": 86.7,
      "fantasyPointsPpr": 118.7,
      "totalYards": 587,
      "totalTds": 4
    },
    "perGame": {
      "fantasyPoints": 5.4,
      "fantasyPointsPpr": 7.4,
      "totalYards": 36.7,
      "totalTds": 0.25,
      "receptions": 2,
      "targets": 4.1,
      "passingYards": 0,
      "rushingYards": 0.6,
      "receivingYards": 36.1
    },
    "bestWeek": {
      "week": 8,
      "fantasyPointsPpr": 18,
      "totalYards": 70,
      "totalTds": 1,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 70
    }
  },
  "sleeper-11834": {
    "season": "2024",
    "games": 14,
    "team": "DEN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 41,
      "targets": 57,
      "receivingYards": 475,
      "receivingTds": 3,
      "fantasyPoints": 65.5,
      "fantasyPointsPpr": 106.5,
      "totalYards": 475,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 4.7,
      "fantasyPointsPpr": 7.6,
      "totalYards": 33.9,
      "totalTds": 0.21,
      "receptions": 2.9,
      "targets": 4.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 33.9
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 15,
      "totalYards": 50,
      "totalTds": 1,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 50
    }
  },
  "sleeper-4950": {
    "season": "2024",
    "games": 8,
    "team": "JAX",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 27,
      "targets": 47,
      "receivingYards": 379,
      "receivingTds": 1,
      "fantasyPoints": 43.9,
      "fantasyPointsPpr": 70.9,
      "totalYards": 379,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 5.5,
      "fantasyPointsPpr": 8.9,
      "totalYards": 47.4,
      "totalTds": 0.13,
      "receptions": 3.4,
      "targets": 5.9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 47.4
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 19.1,
      "totalYards": 61,
      "totalTds": 1,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 61
    }
  },
  "sleeper-1373": {
    "season": "2024",
    "games": 17,
    "team": "SEA",
    "position": "QB",
    "totals": {
      "completions": 407,
      "attempts": 578,
      "passingYards": 4320,
      "passingTds": 21,
      "interceptions": 15,
      "carries": 53,
      "rushingYards": 272,
      "rushingTds": 2,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 266,
      "fantasyPointsPpr": 266,
      "totalYards": 4592,
      "totalTds": 23
    },
    "perGame": {
      "fantasyPoints": 15.6,
      "fantasyPointsPpr": 15.6,
      "totalYards": 270.1,
      "totalTds": 1.35,
      "receptions": 0,
      "targets": 0,
      "passingYards": 254.1,
      "rushingYards": 16,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 26.3,
      "totalYards": 237,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 223,
      "rushingYards": 14,
      "receivingYards": 0
    }
  },
  "sleeper-5995": {
    "season": "2024",
    "games": 17,
    "team": "BAL",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 59,
      "rushingYards": 290,
      "rushingTds": 1,
      "receptions": 48,
      "targets": 57,
      "receivingYards": 403,
      "receivingTds": 4,
      "fantasyPoints": 99.3,
      "fantasyPointsPpr": 147.3,
      "totalYards": 693,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 5.8,
      "fantasyPointsPpr": 8.7,
      "totalYards": 40.8,
      "totalTds": 0.29,
      "receptions": 2.8,
      "targets": 3.4,
      "passingYards": 0,
      "rushingYards": 17.1,
      "receivingYards": 23.7
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 21.6,
      "totalYards": 96,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 18,
      "receivingYards": 78
    }
  },
  "sleeper-8172": {
    "season": "2024",
    "games": 3,
    "team": "DEN",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 5,
      "targets": 12,
      "receivingYards": 28,
      "receivingTds": 0,
      "fantasyPoints": 2.8,
      "fantasyPointsPpr": 7.8,
      "totalYards": 28,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.9,
      "fantasyPointsPpr": 2.6,
      "totalYards": 9.3,
      "totalTds": 0,
      "receptions": 1.7,
      "targets": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 9.3
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 4.6,
      "totalYards": 16,
      "totalTds": 0,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 16
    }
  },
  "sleeper-7600": {
    "season": "2024",
    "games": 18,
    "team": "PIT",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 68,
      "targets": 82,
      "receivingYards": 668,
      "receivingTds": 7,
      "fantasyPoints": 104.8,
      "fantasyPointsPpr": 172.8,
      "totalYards": 668,
      "totalTds": 7
    },
    "perGame": {
      "fantasyPoints": 5.8,
      "fantasyPointsPpr": 9.6,
      "totalYards": 37.1,
      "totalTds": 0.39,
      "receptions": 3.8,
      "targets": 4.6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 37.1
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 22.5,
      "totalYards": 85,
      "totalTds": 1,
      "receptions": 8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 85
    }
  },
  "sleeper-6768": {
    "season": "2024",
    "games": 11,
    "team": "MIA",
    "position": "QB",
    "totals": {
      "completions": 291,
      "attempts": 399,
      "passingYards": 2867,
      "passingTds": 19,
      "interceptions": 7,
      "carries": 17,
      "rushingYards": 49,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 181.6,
      "fantasyPointsPpr": 181.6,
      "totalYards": 2916,
      "totalTds": 19
    },
    "perGame": {
      "fantasyPoints": 16.5,
      "fantasyPointsPpr": 16.5,
      "totalYards": 265.1,
      "totalTds": 1.73,
      "receptions": 0,
      "targets": 0,
      "passingYards": 260.6,
      "rushingYards": 4.5,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 28.5,
      "totalYards": 315,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 317,
      "rushingYards": -2,
      "receivingYards": 0
    }
  },
  "sleeper-11617": {
    "season": "2024",
    "games": 5,
    "team": "NYJ",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 2,
      "rushingYards": 26,
      "rushingTds": 0,
      "receptions": 3,
      "targets": 6,
      "receivingYards": 16,
      "receivingTds": 0,
      "fantasyPoints": 4.2,
      "fantasyPointsPpr": 7.2,
      "totalYards": 42,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.8,
      "fantasyPointsPpr": 1.4,
      "totalYards": 8.4,
      "totalTds": 0,
      "receptions": 0.6,
      "targets": 1.2,
      "passingYards": 0,
      "rushingYards": 5.2,
      "receivingYards": 3.2
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 2,
      "totalYards": 10,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 10
    }
  },
  "sleeper-1166": {
    "season": "2024",
    "games": 14,
    "team": "ATL",
    "position": "QB",
    "totals": {
      "completions": 303,
      "attempts": 453,
      "passingYards": 3508,
      "passingTds": 18,
      "interceptions": 16,
      "carries": 23,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 176.3,
      "fantasyPointsPpr": 176.3,
      "totalYards": 3508,
      "totalTds": 18
    },
    "perGame": {
      "fantasyPoints": 12.6,
      "fantasyPointsPpr": 12.6,
      "totalYards": 250.6,
      "totalTds": 1.29,
      "receptions": 0,
      "targets": 0,
      "passingYards": 250.6,
      "rushingYards": 0,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 34.4,
      "totalYards": 509,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 509,
      "rushingYards": 0,
      "receivingYards": 0
    }
  },
  "sleeper-4017": {
    "season": "2024",
    "games": 7,
    "team": "CLE",
    "position": "QB",
    "totals": {
      "completions": 137,
      "attempts": 216,
      "passingYards": 1148,
      "passingTds": 5,
      "interceptions": 3,
      "carries": 31,
      "rushingYards": 148,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 76.7,
      "fantasyPointsPpr": 76.7,
      "totalYards": 1296,
      "totalTds": 6
    },
    "perGame": {
      "fantasyPoints": 11,
      "fantasyPointsPpr": 11,
      "totalYards": 185.1,
      "totalTds": 0.86,
      "receptions": 0,
      "targets": 0,
      "passingYards": 164,
      "rushingYards": 21.1,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 3,
      "fantasyPointsPpr": 16.4,
      "totalYards": 222,
      "totalTds": 2,
      "receptions": 0,
      "passingYards": 196,
      "rushingYards": 26,
      "receivingYards": 0
    }
  },
  "sleeper-2750": {
    "season": "2024",
    "games": 5,
    "team": "CHI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 9,
      "targets": 14,
      "receivingYards": 72,
      "receivingTds": 0,
      "fantasyPoints": 7.2,
      "fantasyPointsPpr": 16.2,
      "totalYards": 72,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.4,
      "fantasyPointsPpr": 3.2,
      "totalYards": 14.4,
      "totalTds": 0,
      "receptions": 1.8,
      "targets": 2.8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 14.4
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 6.2,
      "totalYards": 32,
      "totalTds": 0,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 32
    }
  },
  "sleeper-12062": {
    "season": "2024",
    "games": 4,
    "team": "CIN",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 5,
      "targets": 5,
      "receivingYards": 28,
      "receivingTds": 0,
      "fantasyPoints": 2.8,
      "fantasyPointsPpr": 7.8,
      "totalYards": 28,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.7,
      "fantasyPointsPpr": 1.9,
      "totalYards": 7,
      "totalTds": 0,
      "receptions": 1.3,
      "targets": 1.3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 7
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 3.2,
      "totalYards": 12,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 12
    }
  },
  "sleeper-6136": {
    "season": "2024",
    "games": 2,
    "team": "DEN",
    "position": "QB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 4,
      "rushingYards": 5,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 0.5,
      "fantasyPointsPpr": 0.5,
      "totalYards": 5,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.3,
      "fantasyPointsPpr": 0.3,
      "totalYards": 2.5,
      "totalTds": 0,
      "receptions": 0,
      "targets": 0,
      "passingYards": 0,
      "rushingYards": 2.5,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 0.7,
      "totalYards": 7,
      "totalTds": 0,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 7,
      "receivingYards": 0
    }
  },
  "sleeper-6012": {
    "season": "2024",
    "games": 4,
    "team": "CHI",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 6,
      "rushingYards": 23,
      "rushingTds": 0,
      "receptions": 3,
      "targets": 3,
      "receivingYards": 11,
      "receivingTds": 0,
      "fantasyPoints": 3.4,
      "fantasyPointsPpr": 6.4,
      "totalYards": 34,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.8,
      "fantasyPointsPpr": 1.6,
      "totalYards": 8.5,
      "totalTds": 0,
      "receptions": 0.8,
      "targets": 0.8,
      "passingYards": 0,
      "rushingYards": 5.8,
      "receivingYards": 2.8
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 4.1,
      "totalYards": 11,
      "totalTds": 0,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 11
    }
  },
  "sleeper-3258": {
    "season": "2024",
    "games": 12,
    "team": "TEN",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 17,
      "targets": 20,
      "receivingYards": 135,
      "receivingTds": 3,
      "fantasyPoints": 31.5,
      "fantasyPointsPpr": 48.5,
      "totalYards": 135,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 2.6,
      "fantasyPointsPpr": 4,
      "totalYards": 11.3,
      "totalTds": 0.25,
      "receptions": 1.4,
      "targets": 1.7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 11.3
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 11.3,
      "totalYards": 33,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 33
    }
  },
  "sleeper-4995": {
    "season": "2024",
    "games": 3,
    "team": "CAR",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 3,
      "targets": 6,
      "receivingYards": 7,
      "receivingTds": 0,
      "fantasyPoints": 0.7,
      "fantasyPointsPpr": 3.7,
      "totalYards": 7,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.2,
      "fantasyPointsPpr": 1.2,
      "totalYards": 2.3,
      "totalTds": 0,
      "receptions": 1,
      "targets": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 2.3
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 2.4,
      "totalYards": 4,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 4
    }
  },
  "sleeper-4443": {
    "season": "2024",
    "games": 8,
    "team": "SEA",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 8,
      "targets": 12,
      "receivingYards": 65,
      "receivingTds": 0,
      "fantasyPoints": 4.5,
      "fantasyPointsPpr": 12.5,
      "totalYards": 65,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.6,
      "fantasyPointsPpr": 1.6,
      "totalYards": 8.1,
      "totalTds": 0,
      "receptions": 1,
      "targets": 1.5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 8.1
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 3.9,
      "totalYards": 19,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 19
    }
  },
  "sleeper-7527": {
    "season": "2024",
    "games": 10,
    "team": "JAX",
    "position": "QB",
    "totals": {
      "completions": 171,
      "attempts": 262,
      "passingYards": 1672,
      "passingTds": 8,
      "interceptions": 8,
      "carries": 28,
      "rushingYards": 92,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 96.1,
      "fantasyPointsPpr": 96.1,
      "totalYards": 1764,
      "totalTds": 9
    },
    "perGame": {
      "fantasyPoints": 9.6,
      "fantasyPointsPpr": 9.6,
      "totalYards": 176.4,
      "totalTds": 0.9,
      "receptions": 0,
      "targets": 0,
      "passingYards": 167.2,
      "rushingYards": 9.2,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 13,
      "fantasyPointsPpr": 20,
      "totalYards": 241,
      "totalTds": 2,
      "receptions": 0,
      "passingYards": 235,
      "rushingYards": 6,
      "receivingYards": 0
    }
  },
  "sleeper-11201": {
    "season": "2024",
    "games": 7,
    "team": "CLE",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 6,
      "targets": 9,
      "receivingYards": 51,
      "receivingTds": 1,
      "fantasyPoints": 11.1,
      "fantasyPointsPpr": 17.1,
      "totalYards": 51,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 1.6,
      "fantasyPointsPpr": 2.4,
      "totalYards": 7.3,
      "totalTds": 0.14,
      "receptions": 0.9,
      "targets": 1.3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 7.3
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 10.3,
      "totalYards": 13,
      "totalTds": 1,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 13
    }
  },
  "sleeper-9482": {
    "season": "2024",
    "games": 11,
    "team": "LV",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 21,
      "targets": 32,
      "receivingYards": 156,
      "receivingTds": 0,
      "fantasyPoints": 15.6,
      "fantasyPointsPpr": 36.6,
      "totalYards": 156,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.4,
      "fantasyPointsPpr": 3.3,
      "totalYards": 14.2,
      "totalTds": 0,
      "receptions": 1.9,
      "targets": 2.9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 14.2
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 13.8,
      "totalYards": 68,
      "totalTds": 0,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 68
    }
  },
  "sleeper-7812": {
    "season": "2024",
    "games": 5,
    "team": "LAC",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 6,
      "targets": 16,
      "receivingYards": 106,
      "receivingTds": 0,
      "fantasyPoints": 10.6,
      "fantasyPointsPpr": 16.6,
      "totalYards": 106,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 2.1,
      "fantasyPointsPpr": 3.3,
      "totalYards": 21.2,
      "totalTds": 0,
      "receptions": 1.2,
      "targets": 3.2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 21.2
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 7.5,
      "totalYards": 45,
      "totalTds": 0,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 45
    }
  },
  "sleeper-7591": {
    "season": "2024",
    "games": 11,
    "team": "PIT",
    "position": "QB",
    "totals": {
      "completions": 106,
      "attempts": 162,
      "passingYards": 1106,
      "passingTds": 5,
      "interceptions": 1,
      "carries": 62,
      "rushingYards": 289,
      "rushingTds": 5,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 119.1,
      "fantasyPointsPpr": 119.1,
      "totalYards": 1395,
      "totalTds": 10
    },
    "perGame": {
      "fantasyPoints": 10.8,
      "fantasyPointsPpr": 10.8,
      "totalYards": 126.8,
      "totalTds": 0.91,
      "receptions": 0,
      "targets": 0,
      "passingYards": 100.5,
      "rushingYards": 26.3,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 4,
      "fantasyPointsPpr": 32,
      "totalYards": 367,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 312,
      "rushingYards": 55,
      "receivingYards": 0
    }
  },
  "sleeper-3202": {
    "season": "2024",
    "games": 17,
    "team": "NE",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 45,
      "targets": 59,
      "receivingYards": 476,
      "receivingTds": 3,
      "fantasyPoints": 63.6,
      "fantasyPointsPpr": 108.6,
      "totalYards": 476,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 3.7,
      "fantasyPointsPpr": 6.4,
      "totalYards": 28,
      "totalTds": 0.18,
      "receptions": 2.6,
      "targets": 3.5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 28
    },
    "bestWeek": {
      "week": 12,
      "fantasyPointsPpr": 15.9,
      "totalYards": 59,
      "totalTds": 1,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 59
    }
  },
  "sleeper-11595": {
    "season": "2024",
    "games": 1,
    "team": "KC",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 1,
      "receivingYards": 7,
      "receivingTds": 0,
      "fantasyPoints": 0.7,
      "fantasyPointsPpr": 1.7,
      "totalYards": 7,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.7,
      "fantasyPointsPpr": 1.7,
      "totalYards": 7,
      "totalTds": 0,
      "receptions": 1,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 7
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 1.7,
      "totalYards": 7,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 7
    }
  },
  "sleeper-8917": {
    "season": "2024",
    "games": 15,
    "team": "DAL",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 16,
      "rushingYards": 92,
      "rushingTds": 0,
      "receptions": 31,
      "targets": 52,
      "receivingYards": 420,
      "receivingTds": 2,
      "fantasyPoints": 73.2,
      "fantasyPointsPpr": 104.2,
      "totalYards": 512,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 4.9,
      "fantasyPointsPpr": 6.9,
      "totalYards": 34.1,
      "totalTds": 0.13,
      "receptions": 2.1,
      "targets": 3.5,
      "passingYards": 0,
      "rushingYards": 6.1,
      "receivingYards": 28
    },
    "bestWeek": {
      "week": 11,
      "fantasyPointsPpr": 17.6,
      "totalYards": 86,
      "totalTds": 1,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 86
    }
  },
  "sleeper-4993": {
    "season": "2024",
    "games": 16,
    "team": "CIN",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 65,
      "targets": 83,
      "receivingYards": 665,
      "receivingTds": 2,
      "fantasyPoints": 76.5,
      "fantasyPointsPpr": 141.5,
      "totalYards": 665,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 4.8,
      "fantasyPointsPpr": 8.8,
      "totalYards": 41.6,
      "totalTds": 0.13,
      "receptions": 4.1,
      "targets": 5.2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 41.6
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 27,
      "totalYards": 100,
      "totalTds": 2,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 100
    }
  },
  "sleeper-7568": {
    "season": "2024",
    "games": 2,
    "team": "HOU",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 2,
      "targets": 3,
      "receivingYards": 7,
      "receivingTds": 0,
      "fantasyPoints": 0.7,
      "fantasyPointsPpr": 2.7,
      "totalYards": 7,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.3,
      "fantasyPointsPpr": 1.4,
      "totalYards": 3.5,
      "totalTds": 0,
      "receptions": 1,
      "targets": 1.5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 3.5
    },
    "bestWeek": {
      "week": 2,
      "fantasyPointsPpr": 1.4,
      "totalYards": 4,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 4
    }
  },
  "sleeper-12048": {
    "season": "2024",
    "games": 2,
    "team": "SEA",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 10,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 1,
      "receivingYards": -1,
      "receivingTds": 0,
      "fantasyPoints": 0.9,
      "fantasyPointsPpr": 1.9,
      "totalYards": 9,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.5,
      "fantasyPointsPpr": 0.9,
      "totalYards": 4.5,
      "totalTds": 0,
      "receptions": 0.5,
      "targets": 0.5,
      "passingYards": 0,
      "rushingYards": 5,
      "receivingYards": -0.5
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 1,
      "totalYards": 10,
      "totalTds": 0,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 10,
      "receivingYards": 0
    }
  },
  "sleeper-4147": {
    "season": "2024",
    "games": 20,
    "team": "KC",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 21,
      "rushingYards": 100,
      "rushingTds": 1,
      "receptions": 29,
      "targets": 38,
      "receivingYards": 339,
      "receivingTds": 1,
      "fantasyPoints": 55.9,
      "fantasyPointsPpr": 84.9,
      "totalYards": 439,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 2.8,
      "fantasyPointsPpr": 4.2,
      "totalYards": 21.9,
      "totalTds": 0.1,
      "receptions": 1.4,
      "targets": 1.9,
      "passingYards": 0,
      "rushingYards": 5,
      "receivingYards": 16.9
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 13.5,
      "totalYards": 35,
      "totalTds": 1,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 10,
      "receivingYards": 25
    }
  },
  "sleeper-4066": {
    "season": "2024",
    "games": 9,
    "team": "JAX",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 47,
      "targets": 64,
      "receivingYards": 365,
      "receivingTds": 1,
      "fantasyPoints": 42.5,
      "fantasyPointsPpr": 89.5,
      "totalYards": 365,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 4.7,
      "fantasyPointsPpr": 9.9,
      "totalYards": 40.6,
      "totalTds": 0.11,
      "receptions": 5.2,
      "targets": 7.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 40.6
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 18.2,
      "totalYards": 102,
      "totalTds": 0,
      "receptions": 10,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 102
    }
  },
  "sleeper-2306": {
    "season": "2024",
    "games": 11,
    "team": "CLE",
    "position": "QB",
    "totals": {
      "completions": 181,
      "attempts": 296,
      "passingYards": 2121,
      "passingTds": 13,
      "interceptions": 12,
      "carries": 25,
      "rushingYards": 83,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 131.1,
      "fantasyPointsPpr": 131.1,
      "totalYards": 2204,
      "totalTds": 14
    },
    "perGame": {
      "fantasyPoints": 11.9,
      "fantasyPointsPpr": 11.9,
      "totalYards": 200.4,
      "totalTds": 1.27,
      "receptions": 0,
      "targets": 0,
      "passingYards": 192.8,
      "rushingYards": 7.5,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 13,
      "fantasyPointsPpr": 33,
      "totalYards": 508,
      "totalTds": 4,
      "receptions": 0,
      "passingYards": 497,
      "rushingYards": 11,
      "receivingYards": 0
    }
  },
  "sleeper-9479": {
    "season": "2024",
    "games": 14,
    "team": "PIT",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 20,
      "targets": 28,
      "receivingYards": 209,
      "receivingTds": 1,
      "fantasyPoints": 26.9,
      "fantasyPointsPpr": 46.9,
      "totalYards": 209,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 1.9,
      "fantasyPointsPpr": 3.4,
      "totalYards": 14.9,
      "totalTds": 0.07,
      "receptions": 1.4,
      "targets": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 14.9
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 7.6,
      "totalYards": 36,
      "totalTds": 0,
      "receptions": 4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 36
    }
  },
  "sleeper-8207": {
    "season": "2024",
    "games": 9,
    "team": "IND",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 32,
      "rushingYards": 153,
      "rushingTds": 1,
      "receptions": 11,
      "targets": 15,
      "receivingYards": 61,
      "receivingTds": 1,
      "fantasyPoints": 33.4,
      "fantasyPointsPpr": 44.4,
      "totalYards": 214,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 3.7,
      "fantasyPointsPpr": 4.9,
      "totalYards": 23.8,
      "totalTds": 0.22,
      "receptions": 1.2,
      "targets": 1.7,
      "passingYards": 0,
      "rushingYards": 17,
      "receivingYards": 6.8
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 11.1,
      "totalYards": 51,
      "totalTds": 1,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 51,
      "receivingYards": 0
    }
  },
  "sleeper-12357": {
    "season": "2024",
    "games": 2,
    "team": "TEN",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 2,
      "receivingYards": 6,
      "receivingTds": 0,
      "fantasyPoints": 0.6,
      "fantasyPointsPpr": 1.6,
      "totalYards": 6,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.3,
      "fantasyPointsPpr": 0.8,
      "totalYards": 3,
      "totalTds": 0,
      "receptions": 0.5,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 3
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 1.6,
      "totalYards": 6,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 6
    }
  },
  "sleeper-9501": {
    "season": "2024",
    "games": 16,
    "team": "NE",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 16,
      "rushingTds": 0,
      "receptions": 66,
      "targets": 87,
      "receivingYards": 621,
      "receivingTds": 3,
      "fantasyPoints": 81.7,
      "fantasyPointsPpr": 147.7,
      "totalYards": 637,
      "totalTds": 3
    },
    "perGame": {
      "fantasyPoints": 5.1,
      "fantasyPointsPpr": 9.2,
      "totalYards": 39.8,
      "totalTds": 0.19,
      "receptions": 4.1,
      "targets": 5.4,
      "passingYards": 0,
      "rushingYards": 1,
      "receivingYards": 38.8
    },
    "bestWeek": {
      "week": 6,
      "fantasyPointsPpr": 21.2,
      "totalYards": 92,
      "totalTds": 1,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 92
    }
  },
  "sleeper-11157": {
    "season": "2024",
    "games": 1,
    "team": "WAS",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 1,
      "receivingYards": -2,
      "receivingTds": 0,
      "fantasyPoints": -0.2,
      "fantasyPointsPpr": 0.8,
      "totalYards": -2,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": -0.2,
      "fantasyPointsPpr": 0.8,
      "totalYards": -2,
      "totalTds": 0,
      "receptions": 1,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": -2
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 0.8,
      "totalYards": -2,
      "totalTds": 0,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": -2
    }
  },
  "sleeper-11895": {
    "season": "2024",
    "games": 9,
    "team": "NO",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 14,
      "targets": 26,
      "receivingYards": 99,
      "receivingTds": 0,
      "fantasyPoints": 9.9,
      "fantasyPointsPpr": 23.9,
      "totalYards": 99,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.1,
      "fantasyPointsPpr": 2.7,
      "totalYards": 11,
      "totalTds": 0,
      "receptions": 1.6,
      "targets": 2.9,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 11
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 10.5,
      "totalYards": 45,
      "totalTds": 0,
      "receptions": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 45
    }
  },
  "sleeper-7842": {
    "season": "2024",
    "games": 10,
    "team": "JAX",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 12,
      "targets": 17,
      "receivingYards": 67,
      "receivingTds": 0,
      "fantasyPoints": 6.7,
      "fantasyPointsPpr": 18.7,
      "totalYards": 67,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.7,
      "fantasyPointsPpr": 1.9,
      "totalYards": 6.7,
      "totalTds": 0,
      "receptions": 1.2,
      "targets": 1.7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 6.7
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 3.7,
      "totalYards": 17,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 17
    }
  },
  "sleeper-19": {
    "season": "2024",
    "games": 7,
    "team": "IND",
    "position": "QB",
    "totals": {
      "completions": 162,
      "attempts": 248,
      "passingYards": 1761,
      "passingTds": 12,
      "interceptions": 7,
      "carries": 9,
      "rushingYards": 26,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 99,
      "fantasyPointsPpr": 99,
      "totalYards": 1787,
      "totalTds": 12
    },
    "perGame": {
      "fantasyPoints": 14.1,
      "fantasyPointsPpr": 14.1,
      "totalYards": 255.3,
      "totalTds": 1.71,
      "receptions": 0,
      "targets": 0,
      "passingYards": 251.6,
      "rushingYards": 3.7,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 26.6,
      "totalYards": 381,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 359,
      "rushingYards": 22,
      "receivingYards": 0
    }
  },
  "sleeper-11320": {
    "season": "2024",
    "games": 1,
    "team": "KC",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 2,
      "targets": 6,
      "receivingYards": 48,
      "receivingTds": 0,
      "fantasyPoints": 4.8,
      "fantasyPointsPpr": 6.8,
      "totalYards": 48,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 4.8,
      "fantasyPointsPpr": 6.8,
      "totalYards": 48,
      "totalTds": 0,
      "receptions": 2,
      "targets": 6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 48
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 6.8,
      "totalYards": 48,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 48
    }
  },
  "sleeper-11199": {
    "season": "2024",
    "games": 13,
    "team": "ARI",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 24,
      "rushingYards": 223,
      "rushingTds": 1,
      "receptions": 16,
      "targets": 20,
      "receivingYards": 104,
      "receivingTds": 0,
      "fantasyPoints": 38.7,
      "fantasyPointsPpr": 54.7,
      "totalYards": 327,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 3,
      "fantasyPointsPpr": 4.2,
      "totalYards": 25.2,
      "totalTds": 0.08,
      "receptions": 1.2,
      "targets": 1.5,
      "passingYards": 0,
      "rushingYards": 17.2,
      "receivingYards": 8
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 16,
      "totalYards": 80,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 59,
      "receivingYards": 21
    }
  },
  "sleeper-11557": {
    "season": "2024",
    "games": 1,
    "team": "NE",
    "position": "QB",
    "totals": {
      "completions": 22,
      "attempts": 29,
      "passingYards": 241,
      "passingTds": 1,
      "interceptions": 0,
      "carries": 10,
      "rushingYards": 16,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 19.2,
      "fantasyPointsPpr": 19.2,
      "totalYards": 257,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 19.2,
      "fantasyPointsPpr": 19.2,
      "totalYards": 257,
      "totalTds": 2,
      "receptions": 0,
      "targets": 0,
      "passingYards": 241,
      "rushingYards": 16,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 19.2,
      "totalYards": 257,
      "totalTds": 2,
      "receptions": 0,
      "passingYards": 241,
      "rushingYards": 16,
      "receivingYards": 0
    }
  },
  "sleeper-7602": {
    "season": "2024",
    "games": 14,
    "team": "IND",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 14,
      "targets": 31,
      "receivingYards": 182,
      "receivingTds": 0,
      "fantasyPoints": 18.2,
      "fantasyPointsPpr": 32.2,
      "totalYards": 182,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.3,
      "fantasyPointsPpr": 2.3,
      "totalYards": 13,
      "totalTds": 0,
      "receptions": 1,
      "targets": 2.2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 13
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 7.7,
      "totalYards": 47,
      "totalTds": 0,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 47
    }
  },
  "sleeper-11716": {
    "season": "2024",
    "games": 5,
    "team": "ARI",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 6,
      "targets": 7,
      "receivingYards": 37,
      "receivingTds": 0,
      "fantasyPoints": 3.7,
      "fantasyPointsPpr": 9.7,
      "totalYards": 37,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.7,
      "fantasyPointsPpr": 1.9,
      "totalYards": 7.4,
      "totalTds": 0,
      "receptions": 1.2,
      "targets": 1.4,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 7.4
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 2.8,
      "totalYards": 8,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 8
    }
  },
  "sleeper-2307": {
    "season": "2024",
    "games": 5,
    "team": "WAS",
    "position": "QB",
    "totals": {
      "completions": 34,
      "attempts": 44,
      "passingYards": 364,
      "passingTds": 4,
      "interceptions": 0,
      "carries": 20,
      "rushingYards": 93,
      "rushingTds": 1,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 45.9,
      "fantasyPointsPpr": 45.9,
      "totalYards": 457,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 9.2,
      "fantasyPointsPpr": 9.2,
      "totalYards": 91.4,
      "totalTds": 1,
      "receptions": 0,
      "targets": 0,
      "passingYards": 72.8,
      "rushingYards": 18.6,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 26,
      "totalYards": 217,
      "totalTds": 3,
      "receptions": 0,
      "passingYards": 161,
      "rushingYards": 56,
      "receivingYards": 0
    }
  },
  "sleeper-8119": {
    "season": "2024",
    "games": 16,
    "team": "PHI",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 1,
      "rushingYards": 13,
      "rushingTds": 0,
      "receptions": 22,
      "targets": 38,
      "receivingYards": 269,
      "receivingTds": 1,
      "fantasyPoints": 34.2,
      "fantasyPointsPpr": 56.2,
      "totalYards": 282,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 2.1,
      "fantasyPointsPpr": 3.5,
      "totalYards": 17.6,
      "totalTds": 0.06,
      "receptions": 1.4,
      "targets": 2.4,
      "passingYards": 0,
      "rushingYards": 0.8,
      "receivingYards": 16.8
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 16.4,
      "totalYards": 94,
      "totalTds": 0,
      "receptions": 7,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 94
    }
  },
  "sleeper-11571": {
    "season": "2024",
    "games": 9,
    "team": "NYJ",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 30,
      "rushingYards": 174,
      "rushingTds": 1,
      "receptions": 9,
      "targets": 12,
      "receivingYards": 75,
      "receivingTds": 1,
      "fantasyPoints": 36.9,
      "fantasyPointsPpr": 45.9,
      "totalYards": 249,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 4.1,
      "fantasyPointsPpr": 5.1,
      "totalYards": 27.7,
      "totalTds": 0.22,
      "receptions": 1,
      "targets": 1.3,
      "passingYards": 0,
      "rushingYards": 19.3,
      "receivingYards": 8.3
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 15.7,
      "totalYards": 67,
      "totalTds": 1,
      "receptions": 3,
      "passingYards": 0,
      "rushingYards": 40,
      "receivingYards": 27
    }
  },
  "sleeper-11377": {
    "season": "2024",
    "games": 1,
    "team": "BUF",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 1,
      "receivingYards": 69,
      "receivingTds": 1,
      "fantasyPoints": 12.9,
      "fantasyPointsPpr": 13.9,
      "totalYards": 69,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 12.9,
      "fantasyPointsPpr": 13.9,
      "totalYards": 69,
      "totalTds": 1,
      "receptions": 1,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 69
    },
    "bestWeek": {
      "week": 17,
      "fantasyPointsPpr": 13.9,
      "totalYards": 69,
      "totalTds": 1,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 69
    }
  },
  "sleeper-11729": {
    "season": "2024",
    "games": 4,
    "team": "DET",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 6,
      "rushingYards": 14,
      "rushingTds": 0,
      "receptions": 3,
      "targets": 3,
      "receivingYards": 37,
      "receivingTds": 0,
      "fantasyPoints": 5.1,
      "fantasyPointsPpr": 8.1,
      "totalYards": 51,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 1.3,
      "fantasyPointsPpr": 2,
      "totalYards": 12.8,
      "totalTds": 0,
      "receptions": 0.8,
      "targets": 0.8,
      "passingYards": 0,
      "rushingYards": 3.5,
      "receivingYards": 9.3
    },
    "bestWeek": {
      "week": 16,
      "fantasyPointsPpr": 4,
      "totalYards": 20,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 20
    }
  },
  "sleeper-4054": {
    "season": "2024",
    "games": 12,
    "team": "IND",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 12,
      "targets": 22,
      "receivingYards": 147,
      "receivingTds": 1,
      "fantasyPoints": 20.7,
      "fantasyPointsPpr": 32.7,
      "totalYards": 147,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 1.7,
      "fantasyPointsPpr": 2.7,
      "totalYards": 12.3,
      "totalTds": 0.08,
      "receptions": 1,
      "targets": 1.8,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 12.3
    },
    "bestWeek": {
      "week": 5,
      "fantasyPointsPpr": 11.7,
      "totalYards": 37,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 37
    }
  },
  "sleeper-7039": {
    "season": "2024",
    "games": 1,
    "team": "SEA",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 2,
      "targets": 3,
      "receivingYards": 44,
      "receivingTds": 0,
      "fantasyPoints": 4.4,
      "fantasyPointsPpr": 6.4,
      "totalYards": 44,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 4.4,
      "fantasyPointsPpr": 6.4,
      "totalYards": 44,
      "totalTds": 0,
      "receptions": 2,
      "targets": 3,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 44
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 6.4,
      "totalYards": 44,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 44
    }
  },
  "sleeper-6039": {
    "season": "2024",
    "games": 20,
    "team": "BUF",
    "position": "RB",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 61,
      "rushingYards": 307,
      "rushingTds": 1,
      "receptions": 22,
      "targets": 29,
      "receivingYards": 318,
      "receivingTds": 4,
      "fantasyPoints": 92.5,
      "fantasyPointsPpr": 114.5,
      "totalYards": 625,
      "totalTds": 5
    },
    "perGame": {
      "fantasyPoints": 4.6,
      "fantasyPointsPpr": 5.7,
      "totalYards": 31.3,
      "totalTds": 0.25,
      "receptions": 1.1,
      "targets": 1.4,
      "passingYards": 0,
      "rushingYards": 15.3,
      "receivingYards": 15.9
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 17.3,
      "totalYards": 123,
      "totalTds": 0,
      "receptions": 5,
      "passingYards": 0,
      "rushingYards": 9,
      "receivingYards": 114
    }
  },
  "sleeper-8250": {
    "season": "2024",
    "games": 1,
    "team": "TEN",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 1,
      "targets": 2,
      "receivingYards": 49,
      "receivingTds": 1,
      "fantasyPoints": 10.9,
      "fantasyPointsPpr": 11.9,
      "totalYards": 49,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 10.9,
      "fantasyPointsPpr": 11.9,
      "totalYards": 49,
      "totalTds": 1,
      "receptions": 1,
      "targets": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 49
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 11.9,
      "totalYards": 49,
      "totalTds": 1,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 49
    }
  },
  "sleeper-7075": {
    "season": "2024",
    "games": 8,
    "team": "ATL",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 7,
      "targets": 12,
      "receivingYards": 46,
      "receivingTds": 0,
      "fantasyPoints": 4.6,
      "fantasyPointsPpr": 11.6,
      "totalYards": 46,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0.6,
      "fantasyPointsPpr": 1.4,
      "totalYards": 5.8,
      "totalTds": 0,
      "receptions": 0.9,
      "targets": 1.5,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 5.8
    },
    "bestWeek": {
      "week": 15,
      "fantasyPointsPpr": 2.7,
      "totalYards": 7,
      "totalTds": 0,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 7
    }
  },
  "sleeper-7585": {
    "season": "2024",
    "games": 4,
    "team": "HOU",
    "position": "QB",
    "totals": {
      "completions": 20,
      "attempts": 36,
      "passingYards": 212,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 3,
      "rushingYards": 11,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 9.6,
      "fantasyPointsPpr": 9.6,
      "totalYards": 223,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 2.4,
      "fantasyPointsPpr": 2.4,
      "totalYards": 55.8,
      "totalTds": 0,
      "receptions": 0,
      "targets": 0,
      "passingYards": 53,
      "rushingYards": 2.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 18,
      "fantasyPointsPpr": 6.2,
      "totalYards": 139,
      "totalTds": 0,
      "receptions": 0,
      "passingYards": 128,
      "rushingYards": 11,
      "receivingYards": 0
    }
  },
  "sleeper-11256": {
    "season": "2024",
    "games": 4,
    "team": "CHI",
    "position": "QB",
    "totals": {
      "completions": 2,
      "attempts": 2,
      "passingYards": 11,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 6,
      "rushingYards": -7,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 0,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": -0.3,
      "fantasyPointsPpr": -0.3,
      "totalYards": 4,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": -0.1,
      "fantasyPointsPpr": -0.1,
      "totalYards": 1,
      "totalTds": 0,
      "receptions": 0,
      "targets": 0,
      "passingYards": 2.8,
      "rushingYards": -1.8,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 14,
      "fantasyPointsPpr": 0.2,
      "totalYards": 6,
      "totalTds": 0,
      "receptions": 0,
      "passingYards": 6,
      "rushingYards": 0,
      "receivingYards": 0
    }
  },
  "sleeper-7536": {
    "season": "2024",
    "games": 5,
    "team": "BUF",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 5,
      "targets": 8,
      "receivingYards": 36,
      "receivingTds": 1,
      "fantasyPoints": 9.6,
      "fantasyPointsPpr": 14.6,
      "totalYards": 36,
      "totalTds": 1
    },
    "perGame": {
      "fantasyPoints": 1.9,
      "fantasyPointsPpr": 2.9,
      "totalYards": 7.2,
      "totalTds": 0.2,
      "receptions": 1,
      "targets": 1.6,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 7.2
    },
    "bestWeek": {
      "week": 9,
      "fantasyPointsPpr": 7.2,
      "totalYards": 2,
      "totalTds": 1,
      "receptions": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 2
    }
  },
  "sleeper-8861": {
    "season": "2024",
    "games": 1,
    "team": "NYJ",
    "position": "WR",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 0,
      "targets": 1,
      "receivingYards": 0,
      "receivingTds": 0,
      "fantasyPoints": 0,
      "fantasyPointsPpr": 0,
      "totalYards": 0,
      "totalTds": 0
    },
    "perGame": {
      "fantasyPoints": 0,
      "fantasyPointsPpr": 0,
      "totalYards": 0,
      "totalTds": 0,
      "receptions": 0,
      "targets": 1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 0
    },
    "bestWeek": {
      "week": 7,
      "fantasyPointsPpr": 0,
      "totalYards": 0,
      "totalTds": 0,
      "receptions": 0,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 0
    }
  },
  "sleeper-4314": {
    "season": "2024",
    "games": 14,
    "team": "MIN",
    "position": "TE",
    "totals": {
      "completions": 0,
      "attempts": 0,
      "passingYards": 0,
      "passingTds": 0,
      "interceptions": 0,
      "carries": 0,
      "rushingYards": 0,
      "rushingTds": 0,
      "receptions": 21,
      "targets": 30,
      "receivingYards": 170,
      "receivingTds": 2,
      "fantasyPoints": 29,
      "fantasyPointsPpr": 50,
      "totalYards": 170,
      "totalTds": 2
    },
    "perGame": {
      "fantasyPoints": 2.1,
      "fantasyPointsPpr": 3.6,
      "totalYards": 12.1,
      "totalTds": 0.14,
      "receptions": 1.5,
      "targets": 2.1,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 12.1
    },
    "bestWeek": {
      "week": 13,
      "fantasyPointsPpr": 10.2,
      "totalYards": 22,
      "totalTds": 1,
      "receptions": 2,
      "passingYards": 0,
      "rushingYards": 0,
      "receivingYards": 22
    }
  }
};

export const positionAverages = {
  "RB": {
    "sampleSize": 47,
    "perGame": {
      "fantasyPointsPpr": 10,
      "totalYards": 59,
      "totalTds": 0.39,
      "receptions": 1.9,
      "targets": 2.3,
      "passingYards": 0,
      "rushingYards": 44.4,
      "receivingYards": 14.6
    }
  },
  "QB": {
    "sampleSize": 36,
    "perGame": {
      "fantasyPointsPpr": 14,
      "totalYards": 211.7,
      "totalTds": 1.38,
      "receptions": 0,
      "targets": 0,
      "passingYards": 195.9,
      "rushingYards": 15.8,
      "receivingYards": 0
    }
  },
  "WR": {
    "sampleSize": 73,
    "perGame": {
      "fantasyPointsPpr": 11.2,
      "totalYards": 52.4,
      "totalTds": 0.34,
      "receptions": 3.9,
      "targets": 6,
      "passingYards": 0.1,
      "rushingYards": 1.2,
      "receivingYards": 51.1
    }
  },
  "TE": {
    "sampleSize": 42,
    "perGame": {
      "fantasyPointsPpr": 6.4,
      "totalYards": 27.4,
      "totalTds": 0.16,
      "receptions": 2.7,
      "targets": 3.8,
      "passingYards": 0,
      "rushingYards": 0.1,
      "receivingYards": 27.3
    }
  }
};
